// ----------------------------------------------------------------------

const he = {
  Sunday: 'יום ראשון',
  Monday: 'יום שני',
  Tuesday: 'יום שלישי',
  Wednesday: 'יום רביעי',
  Thursday: 'יום חמישי',
  Friday: 'יום שישי',
  Saturday: 'יום שבת',
  charge_type: {
    "manual-charge": "חיוב ידני",
    "subscription": "מנוי",
    "top-up": "טופ אפ",
    "default": "ברירת מחדל"
  },
  currency: {
    name: 'ש״ח',
    symbol: '₪',
    format: '{{value}} ₪',
  },
  powered_by: 'נבנה על',
  collaborator_name: 'שם המשווק',
  whatsapp_support: 'דברו איתנו ב WhatsApp',
  approved_for_subscription_purchase: 'מאושר לרכישת מנוי',
  // Funnel translations
  Views: 'צפיות',
  'Unique Visitors': 'מבקרים',
  'Ordered Tickets': 'כרטיסים שהוזמנו',
  'Approved Tickets': 'כרטיסים מאושרים',
  'Refunded Tickets': 'כרטיסים שזוכו',
  'Share link': 'שתף קישור',
  'Purchases': 'רכישות',
  'Birthday': 'יום הולדת',
  'First name': 'שם פרטי',
  'Last name': 'שם משפחה',
  'Email': 'אימייל',
  'Phone': 'טלפון',
  'Gender': 'מין',
  'Link to social network such as Facebook, Instagram, etc.': 'קישור לרשת חברתית כמו פייסבוק, אינסטגרם, וכו',
  "event-type": "סוג אירוע",
  directions: 'הוראות הגעה',
  required_field: 'שדה חובה',
  no_access: 'אין לך הרשאה מתאימה',
  hello: 'שלום',
  world: 'עולם',
  continue: 'המשך',
  wellness_event: 'אירוע וולנס',
  got_an_account: 'יש לכם חשבון?',
  login_here: 'התחברו כאן',
  press_here: 'לחצו כאן',
  to_my_account: 'לאזור האישי',
  to_events: 'להזמנת כרטיסים',
  dont_have_an_account: 'אין לכם חשבון?',
  add_comment: 'הוסף הערה',
  edit_comment: 'ערוך הערה',
  book_now: 'הזמן עכשיו',
  location: 'מיקום',
  excel_file: `קובץ אקסל`,
  calendar: 'יומן',
  start_hour: 'שעת התחלה',
  comment_updated_success: 'הערה עודכנה בהצלחה',
  save: 'שמירה',
  hi: 'הי',
  type: 'סוג',
  event: 'אירוע',
  url: 'קישור',
  link: 'קישור',
  default: 'ברירת מחדל',
  html: 'HTML',
  cancel: 'ביטול',
  pdf: 'PDF',
  start_date: `תאריך התחלה`,
  end_date: `תאריך סיום`,
  logout: 'התנתקות',
  edit: 'עריכה',
  edit_profile: 'עריכת פרופיל',
  basic_information: 'מידע בסיסי',
  additional_information: 'מידע נוסף',
  not_logged_in: 'אתם לא מחוברים ',
  "entry-pass": 'כרטיסייה',
  "user-created": '  ידני ',
  "season-ticket-entry-pass": 'כרטיסייה',
  "season-ticket": 'מנוי',
  "booked_events": 'ההזמנות שלך',
  "my_subscriptions": 'המנויים שלך',
  financial: 'כספים',
  links: {
    table: {
      name: 'שם',
      description: 'תיאור',
      utm: 'לינק',
      createdAt: 'תאריך יצירה',
      tickets: 'כרטיסים',
      isActive: 'סטאטוס',
      sessions: 'סאשנים',
      usersViews: 'יוזרים',
      sold_count: 'כרטיסים נמכרו',
      refund_count: 'כרטיסים זוכו',
      cancel_count: 'כרטיסים בוטלו',
      pending_count: 'כרטיסים ממתינים לאישור'
    },
    form: {
      name: 'שם',
      description: 'תיאור',
      ticketsPerPurchase: 'מספר כרטיסים לרכישה',
      ticketsPerPurchaseHelper: 'מספר הכרטיסים הזמינים לרכישה עבור לינק זה',
      amountToCreate: 'כמות לינקים ליצירה',
      isActive: 'פעיל',
      tickets: 'כרטיסים',
      ticketsHelper: 'כרטיסים שיוצגו בעמוד',
      noCollaborator: 'לא מוקצה משווק',
      noCollaboratorsHelper: 'ניתן להזמין משווקים ולעקוב אחר ביצועי השיווק שלהם',
      clickToInviteMarketers: 'לחצו כאן להזמנת משווקים'
    },
    primary: 'ראשי',
    heading: 'לינקים',
    view_details: 'צפה בפרטים',
    dialog: {
      update_title: 'עדכון לינק',
      create_title: 'יצירת לינק',
      update_button: 'עדכן לינק',
      create_button: 'צור לינק'
    }
  },
  season_ticket: {

    cannot_change_cancelled: 'לא ניתן לשנות מנוי שבוטל',
    title: 'מנוי',
    customer_club: 'מועדון לקוחות',
    letters_only: 'אותיות באנגלית או עברית בלבד, ללא סימנים',
    unlimited_entries: 'על מנת לאפשר ניקובים ללא הגבלה, 0 או השאר ריק',
    discount_will_appear_after_choosing_tickets: 'הנחת החברות תופיע בהמשך לאחר בחירת הכרטיסים',
    status: 'סטטוס מנוי',
    subscription_notes: 'הערות מנוי',
    subscription_end_of_month_notice: "החיוב החודשי למנוים שנרכשו לאחר ה28 לחודש יתבצע בראשון לחודש",
    discount: {
      created_successfully: 'הנחה נוצרה בהצלחה!',
      updated_successfully: 'הנחה עודכנה בהצלחה!'
    },
    entry_pass: {
      title: 'כרטיסייה',
      usage: 'השתמשת ב {{0}} מתוך {{1}}',
      available_entries: 'כניסות שניתן לממש באירוע זה',
      max_available_entries: 'מקסימום כניסות באירוע אחד',
      total_tickets_allowed: ' מספר הכניסות שהכרטיסיה מקנה',
      no_entries_left: 'לא נותרו לך כניסות למימוש באירוע זה'
    },
    code: 'קוד מנוי',
    table: {
      title: 'מנויים',
      name: 'שם',
      price: 'מחיר',
      type: 'סוג',
      create_subscription: 'יצירת מנוי',
      create_entry_pass: 'יצירת כרטיסייה',
      payment_type: 'סוג חיוב',
      payment_limit: 'הגבלת חיובים',
      event_limit: 'הגבלת אירועים',
      status: 'סטטוס',
      actions: 'פעולות',
      code: 'קוד מנוי',
      subscription_type: 'סוג מנוי',
      transactions_allowed: 'כניסות מותרות',
      transactions_used: 'כניסות שנוצלו',
      iterations_completed: 'חיובים שבוצעו',
      iterations: 'תשלומים',
      payment_date: 'תאריך תשלום',
      next_date: 'תאריך הבא',
      start_date: 'תאריך התחלה',
      hrc: 'קוד '
    },
    dialog: {
      select_season_ticket: 'מנוי',
      add_to_customer: 'הוסף ללקוח',
      click_to_add_free: 'לחצו כאן כדי להוסיף מנוי חינם',
      free_subscription: 'מנוי חינם',
      proceed_to_payment: 'המשיכו לתשלום',
      cannot_resume_not_paused: 'ניתן להמשיך רק ממנוי מושהה',
      cannot_change_cancelled: 'לא ניתן לשנות מנוי שבוטל',
      select_price: 'יש לבחור מחיר',
      end_user_season_ticket_already_in_the_same_status: 'כרטיס עונה של משתמש קצה כבר במצב זהה',
      edit_title: 'עריכת מנוי',
      create_title: 'יצירת מנוי',
      create_entry_pass_title: 'יצירת כרטיסייה',
      name: 'שם',
      event_limit: 'הגבלת מספר רכישות לאירועים',
      event_limit_helper: 'למשל אם תרצו שהמנוי יכנס למקסימום 30 אירועים במהלך תקופת המנוי',
      price: 'מחיר',
      payment_type: 'סוג חיוב המנוי',
      payment_types: {
        daily: 'יומי',
        weekly: 'שבועי',
        monthly: 'חודשי',
        yearly: 'שנתי'
      },
      payment_limit: 'הגבלת מספר חיובים',
      unlimited: 'ללא הגבלה',
      show_in_seller_page: 'הצג בעמוד מוכר',
      start_date: 'תאריך התחלה',
      description: 'תיאור',
      submit: 'אישור',
      name_exists: 'שם זה כבר קיים במערכת',
      updated_successfully: 'מנוי עודכן בהצלחה',
      created_successfully: 'מנוי נוצר בהצלחה!',
      unlimited_purchases: 'על מנת לאפשר רכישה ללא הגבלה, 0 או השאר ריק',
      edit_status: 'עדכון סטטוס מנוי',
      status_description: {
        paused: 'הקפאת חיובים',
        cancelled: 'ביטול סופי',
        active: 'הפעלת חיובים'
      }
    },
    types: {
      entry_pass: 'כרטיסייה',
    },
  },
  manual_segment: 'ידני',
  event_segment: 'אירוע',
  finance_segment: 'כספים',
  segments: {
    manual_selection: 'בחירה ידנית של הלקוחות לסגמנט',
    event_auto_add: 'המערכת תוסיף את כל הלקוחות שרכשו כרטיס לאירוע באופן אוטמטי',
    season_ticket_auto_add: 'המערכת תוסיף את כל הלקוחות המנוים באופן אוטומטי',
    entry_pass_auto_add: 'המערכת תוסיף את כל הלקוחות שרכשו כרטיסייה באופן אוטומטי',
    activity_auto_add: 'המערכת תוסיף את כל הלקוחות שביצעו פעילות מסוימת באופן אוטומטי',
    event_type_auto_add: 'המערכת תוסיף את כל הלקוחות שהשתתפו באירוע מסוג מסוים באופן אוטומטי',
    add_to_segment: 'הוסף לסגמנט',
    remove_from_segment: 'הסר מסגמנט',
    status: {
      active: 'פעיל',
      paused: 'מושהה',
      cancelled: 'בוטל',
      cancel_at_period_end: 'בטל במועד החיוב הבא',
      initial: 'נוצר',
    },
    required_field: 'שדה חובה',
    short_url: 'כתובת מקוצרת',
    sync_message: 'כדי לוודא שהסגמנט שלך מכיל את המידע העדכני ביותר, יש ללחוץ על "סינכרון סגמנטים"',
    sync_explanation: {
      what_is_it: 'מה זה אומר?',
      update_list: 'פעולת הסינכרון מעדכנת את רשימת האנשים בסגמנט בהתאם לתנאים שהגדרת.',
      example: 'נניח שהגדרת סגמנט בשם "מנוי חודשי". הסגמנט מוגדר כך שיכלול את כל הלקוחות שרכשו מנוי. בכל פעם שתלחץ על "סינכרון סגמנטים", המערכת תבדוק את רשימת הלקוחות ותוסיף לסגמנט "מנוי חודשי" את כל מי שרכש מנוי עד לרגע הסינכרון.',
      always_updated: 'סינכרון הסגמנטים מבטיח שהמידע בסגמנט יהיה תמיד מעודכן.',
    },
    create: 'צור',
    created_success: 'סגמנט חדש נוצר בהצלחה!',
    updated_success: 'סגמנט עודכן בהצלחה!',
    handler_exists: 'כתובת מקוצרת זו כבר קיימת',
    new_segment: 'סגמנט חדש',
    edit_segment: 'עריכת סגמנט',
    create_new: 'יצירת סגמנט חדש',
    assign_customers: 'שיווך לקוחות לסגמנט',
    customers_removed: 'לקחוחות הוסרו מסגמנט בהצלחה',
    customers_added: 'הלקוחות הוספו לסגמנט בהצלחה',
    manual_sync_error: 'לא ניתן לסנכרן סגמנטים ידניים',
    sync_success: 'סינכרון סגמנטים בוצע בהצלחה',
  },
  activity: 'פעילות',
  end_user: {
    dynamic_fields: "מידע נוסף",
    created_success: 'לקוח נוצר בהצלחה!',
    add_new: 'הוסף לקוח חדש',
    customer_page: 'עמוד לקוח',
    search: 'חיפוש לפי שם, אימייל, טלפון...',
    search_crm_events: 'חיפוש לפי שם, תיאור, פעולה...',
    search_orders: 'חיפוש לפי מספר הזמנה, אירוע, הפקה...',
    search_charges: 'חיפוש לפי קוד, תיאור, סכום...',
    export: {
      index: '#',
      name: 'שם לקוח',
      email: 'אימייל',
      phone: 'מספר טלפון',
      birth_date: 'תאריך לידה',
      social_link: 'קישור לסושיאל',
      download_data: 'הורדת נתונים',
      download_selected: 'הורדת לקוחות שסומנו בלבד',
      download_all: 'הורדת כל הלקוחות',
      customer_list: 'רשימת לקוחות',
    },
    import: {
      button: 'ייבוא מאקסל',
      title: 'ייבוא לקוחות',
      step_upload: 'העלאת קובץ',
      step_mapping: 'מיפוי עמודות',
      step_segment: 'שם סגמנט',
      step_progress: 'התקדמות',
      supported_formats: 'פורמטים נתמכים: אקסל (xlsx, xls.) וCSV (.csv)',
      total_rows: 'סך הכל שורות שנמצאו',
      map_columns: 'מפה עמודות מהאקסל לשדות לקוח',
      excel_column: 'עמודת אקסל',
      sample_data: 'דוגמת נתונים',
      map_to: 'מיפוי ל',
      skip: 'דלג על עמודה זו',
      phone_required: 'מיפוי שדה טלפון הוא חובה',
      segment_name_required: 'שם הסגמנט הוא חובה',
      segment_name_label: 'הזן שם לסגמנט החדש',
      segment_name_placeholder: 'לדוגמה, ייבוא ינואר 2025',
      segment_info: 'כל הלקוחות המיובאים יתווספו לסגמנט זה',
      default_country_code_label: 'קידומת מדינה',
      default_country_code_info: 'קידומת זו תתווסף למספרי טלפון שאין להם קידומת מדינה',
      starting: 'מתחיל ייבוא...',
      processing: 'מעבד...',
      completed: 'הייבוא הושלם!',
      failed: 'הייבוא נכשל',
      created: 'נוצרו',
      skipped: 'דולגו',
      skipped_info: 'שורות מדולגות כאשר חסרים נתונים נדרשים (שם פרטי, שם משפחה או טלפון), או כאשר מספר הטלפון כבר קיים',
      errors: 'שגיאות',
      errors_found: 'נמצאו שגיאות',
      errors_count: '{{count}} שורות נכשלו',
      summary_title: 'סיכום ייבוא',
      summary_skipped_errors: 'דולגו {{skipped}} שורות ונמצאו {{errors}} שגיאות',
      click_to_download: 'לחץ להורדה כקובץ CSV',
      rows_processed: 'שורות עובדו',
      success: 'הלקוחות יובאו בהצלחה!',
      back: 'חזרה',
      next: 'הבא',
      start: 'התחל ייבוא',
      close: 'סגור',
      // Job recovery and cancel
      importing: '...מייבא',
      cancel: 'בטל ייבוא',
      cancelled: 'הייבוא בוטל',
      cancelled_title: 'הייבוא בוטל',
      cancel_failed: 'ביטול הייבוא נכשל',
      // Format info
      format_info_title: 'דרישות פורמט הקובץ',
      supported_formats_label: 'פורמטים נתמכים',
      file_requirements: 'דרישות',
      req_headers: 'השורה הראשונה חייבת להכיל כותרות עמודות',
      req_phone: 'עמודת טלפון נדרשת עבור כל לקוח',
      req_data: 'הקובץ חייב להכיל לפחות שורת נתונים אחת',
      req_separate_names: 'שם פרטי ושם משפחה חייבים להיות בעמודות נפרדות',
      // Error messages
      error_no_headers: 'לא נמצאו כותרות עמודות',
      error_no_headers_desc: 'נראה שחסרות כותרות עמודות בשורה הראשונה של הקובץ.',
      error_no_headers_fix: 'הוסיפו שורת כותרות עם שמות עמודות כמו "שם פרטי", "טלפון", "אימייל"',
      error_empty_file: 'קובץ ריק',
      error_empty_file_desc: 'הקובץ שהועלה ריק או שלא ניתן לקרוא אותו.',
      error_empty_file_fix: 'ודאו שהקובץ מכיל נתונים ונסו להעלות שוב',
      error_invalid_format: 'פורמט קובץ לא תקין',
      error_invalid_format_desc: 'לא ניתן לעבד את הקובץ. ייתכן שהוא פגום או בפורמט לא נתמך.',
      error_invalid_format_fix: 'שמרו את הקובץ כ-.xlsx, .xls או .csv ונסו שוב',
      error_no_data: 'לא נמצאו שורות נתונים',
      error_no_data_desc: 'הקובץ מכיל כותרות אבל אין שורות נתונים.',
      error_no_data_fix: 'הוסיפו נתוני לקוחות מתחת לשורת הכותרות',
      error_corrupted: 'הקובץ נראה פגום',
      error_corrupted_desc: 'לא ניתן לפתוח את הקובץ. ייתכן שהוא פגום.',
      error_corrupted_fix: 'נסו לפתוח את הקובץ באקסל, שמרו אותו מחדש והעלו שוב',
      error_too_many_rows: 'יותר מדי שורות',
      error_too_many_rows_desc: 'הקובץ מכיל יותר מ-10,000 שורות.',
      error_too_many_rows_fix: 'פצלו את הקובץ לחלקים קטנים יותר עם עד 10,000 שורות בכל חלק',
      error_unknown: 'שגיאה לא ידועה',
      error_unknown_desc: 'אירעה שגיאה בלתי צפויה בעת עיבוד הקובץ.',
      error_unknown_fix: 'אנא נסו שוב או פנו לתמיכה',
      error_upload_failed: 'ההעלאה נכשלה',
      error_try_again: 'אנא בדקו את הקובץ ונסו שוב',
      error_server: 'שגיאת שרת',
      error_server_desc: 'השרת לא הצליח לעבד את הקובץ. ייתכן שהקובץ גדול מדי או מכיל יותר מדי שורות.',
      error_server_fix: 'נסו לפצל את הקובץ לחלקים קטנים יותר (עד 1000 שורות בכל חלק) או צרו קשר עם התמיכה',
      error_file_not_found: 'הקובץ לא נמצא',
      error_file_not_found_desc: 'הקובץ שהועלה לא נמצא באחסון. ייתכן שההעלאה נכשלה.',
      error_file_not_found_fix: 'אנא נסו להעלות את הקובץ שוב'
    },
    customers_of: 'הלקוחות של',
    new_customer: 'לקוח חדש',
    customer_details: 'פרטי לקוח',
    order_history: 'היסטורית הזמנות',
    activity_history: 'היסטורית פעילות',
    comments: 'הערות',
    charges: 'חיובים',
    create_new_charge_tooltip: 'חייב את כרטיס של הלקוח ',
    create_new_charge: 'צור חיוב חדש',
    token_auto_filled: 'טוקן מולא אוטומטית מנתוני המשתמש',
    charge_created_successfully: 'החיוב נוצר בהצלחה',
    charge_new_credit_card: 'חייב כרטיס אשראי חדש',
    charge_stored_credit_card: 'חייב כרטיס אשראי שמור',
    confirm_charge: 'אישור חיוב - {{amount}}',
    charge_confirmation_message: 'האם אתה בטוח שברצונך לחייב משתמש זה?',
    confirm_charge_button: 'אשר חיוב',
    charge_confirmation_title: 'אישור חיוב',
    charge_confirmation_after_approval: 'לאחר אישור הפעולה',
    charge_confirmation_will_be_charged: 'יחויב בסכום של',
    charge_confirmation_for: 'עבור',
    charge_confirmation_do_you_approve: 'האם אתם מאשרים',
    no_seller_public_key: 'מפתח ציבורי של המוכר לא מוגדר',
    customer_credit_card: 'כרטיס האשראי של הלקוח',
    dining_analytics: 'ניתוח הוצאות במסעדה',
    dining: {
      filter_by_date: 'סינון לפי טווח תאריכים',
      start_date: 'תאריך התחלה',
      end_date: 'תאריך סיום',
      reset: 'איפוס',
      total_spent: 'סך הכל הוצאות',
      total_visits: 'סך הכל ביקורים',
      average_spend: 'ממוצע הוצאה לביקור',
      average_duration: 'משך ביקור ממוצע',
      spending_breakdown: 'פירוט הוצאות',
      spending_details: 'פרטי הוצאות',
      food: 'אוכל',
      drinks: 'משקאות',
      visit_history: 'היסטוריית ביקורים',
      no_visits: 'לא נמצאו ביקורים בטווח התאריכים שנבחר',
      table: 'שולחן',
      minutes: 'דקות',
      total: 'סה"כ',
      order_items: 'פריטים בהזמנה',
      total_spending: 'סה"כ'
    },
    store_credit_card_for_future: 'שמור כרטיס אשראי זה לחיובים עתידיים',
    data_error: 'ישנה בעיה עם פרטי הלקוחות, אנא צרו קשר עם מנהל המערכת',
    table: {
      name: 'שם',
      email: 'אימייל',
      phone: 'טלפון',
      fullName: 'שם מלא',
      segments: 'סגמנטים',
      birth_date: 'תאריך לידה',
      last_participation: 'השתתפות אחרונה',
      participation: 'השתתפות',
      created_at: 'הצטרפות',
      social: 'סושיאל',
      status: 'סטטוס',
      join_date: 'הצטרפות',
      cancel_date: 'ביטול',
      price: 'מחיר',
      marketing_approval: 'אישור שיווק',
      production: 'הפקה',
      go_to_order_page: 'מעבר לעמוד הזמנה',
      search: {
        advanced: 'חיפוש מתקדם',
        users_in_segments: 'חפש משתמשים השייכים לסגמנטים אלו',
      },
    },
    exclude_segments: 'אל תכלול משתמשים השייכים לסגמנטים אלו',
    search_from_date: 'חפש החל מתאריך',
    search_to_date: 'חפש עד תאריך',
    search_date_tooltip: 'מחפש רכישה של כרטיס, מנוי, או פעילות שבוצעה החל מהתאריך הזה, בתוך הסגמנטים הקיימים',
    search_to_date_tooltip: 'מחפש רכישה של כרטיס, מנוי, או פעילות שבוצעה עד התאריך הזה, בתוך הסגמנטים הקיימים',
    search_price_tooltip: 'מחפש רכישה של כרטיס, מנוי, או פעילות עם מחיר שגבוה מזה, בתוך הסגמנטים הקיימים',
    search_max_price_tooltip: 'מחפש רכישה של כרטיס, מנוי, או פעילות עם מחיר נמוך מזה, בתוך הסגמנטים הקיימים',
    min_price: 'מחיר מינימום',
    max_price: 'מחיר מקסימום',
    go_to_order_page: 'מעבר לעמוד הזמנה',
    create_new_order: 'צור הזמנה חדשה',
    for_customer: 'עבור לקוח',
    select_production: 'בחירת הפקה',
    productions_with_future_events: 'הפקות עם אירועים עתידיים',
    select_event: 'בחירת אירוע',
    cannot_select_event_before_production: 'לא ניתן לבחור אירוע לפני שבוחרים הפקה',
    future_events_only: 'אירועים עתידיים בלבד',
    select_subscription: 'בחירת מנוי',
    cannot_select_subscription_no_active: 'לא ניתן לבחור מנוי כאשר אין מנויים פעילים',
  },
  hide: 'הסתר',
  verification_code: 'קוד אימות',
  male: `זכר`,
  female: `נקבה`,
  other: `אחר`,
  my_productions: `ההפקות שלי`,
  events: `אירועים`,
  system_users: `משתמשי הפקה`,
  switch: `החלף הפקה`,
  general_error: `ישנה תקלה, אנא נסו שנית`,
  general_success: `הפעולה בוצעה בהצלחה`,
  handler_not_unique: 'כתובת מקוצרת כבר קיימת',
  change_to_light_mode: `מעבר למצב בהיר`,
  change_to_dark_mode: `מעבר למצב חשוך`,
  random_image: `תמונה רנדומלית`,
  my_account: `המשתמש שלי`,
  join_date: `תאריך הצטרפות`,
  iterations_completed: `חיובים שבוצעו`,
  price: `מחיר`,
  phone: `טלפון`,
  fname: 'שם פרטי',
  lname: 'שם משפחה',
  email: 'אימייל',
  search: 'חיפוש',
  cancel_date: 'תאריך ביטול',
  created_at: 'תאריך הצטרפות',
  from: 'החל מ',
  to: 'עד ל',
  refresh: 'רענון',
  refresh_success: 'המידע עודכן בהצלחה',
  cancel_date_to: 'תאריך ביטול עד',
  cancel_date_from: 'תאריך ביטול מ',
  my_details: `הפרטים שלך`,
  edit_account_details: 'עריכה',
  show_more: `הצג עוד`,
  show_all: `הצג הכל`,
  sms: {
    page_title: 'שליחת אסמסים',
    phone_number: 'מספר טלפון',
    phone_numbers: 'מספרי פלאפון',
    no_phone_numbers: 'לא קיימים מספרי טלפון לסגמנטים אלו',
    select_from_segment: 'בחירת מספרי טלפון מסגמנט',
    select_segments: 'בחירת סגמנטים',
    submit: 'אישור',
    sent_success: 'אסמסים נשלחו בהצלחה!',
    send: 'שלח!',
    total_phones: 'סך הכל',
    campaign_name: 'שם הקמפיין',
    campaign_content: 'תוכן הסמס (עד 1000 תווים)',
    add: 'הוספה',
    fill_field: 'נא למלא תא זה',
    duplicate_numbers: 'מספרים זהים',
    add_number: 'הוספת מספר',
    approve: 'אישור',
    close: 'סגור',
    no_sms_campaigns: 'אין קמפיינים ',
    segment_phones: 'מספרי טלפון מסגמנט',
    numbers: 'מספרים',
    you_have_x_sms_credits_left: 'נותרו לך {{x}} אסמסים, צרו קשר עם הצוות שלנו לרכישת חבילת אסמסים',
  },
  sales_table: `טבלת מכירות`,
  my_members: {
    title: 'המנויים שלי',
    error_loading: 'שגיאה בטעינת המנויים שלי',
    refresh: 'רענון',
    refresh_success: 'הנתונים עודכנו בהצלחה',
    search: 'חיפוש',
    name: 'שם',
    from: 'מ',
    to: 'עד',
    general_error: 'שגיאה כללית',
  },
  coming_events: `אירועים קרובים`,
  terms_of_service: 'תנאי שימוש',
  privacy_policy: 'מדיניות פרטיות',
  name: `שם`,
  price_from: 'מחיר מינימום',
  price_to: 'מחיר מקסימום',
  status: 'סטטוס',
  date_from: 'החל מתאריך',
  date_to: 'עד לתאריך',
  all: 'הכל',
  active: 'פעיל',
  not_active: 'לא פעיל',
  roles: {
    all: 'כולם',
    scanner: 'סורק',
    trainer: 'מדריך',
    reader: 'צופה',
    editor: 'עורך',
    admin: 'מנהל',
    promoter: 'משווק',
    owner: 'owner',
  },
  role: 'תפקיד',
  invite: 'הזמן',
  clear: 'נקה',
  remove_user_dialog: {
    title: 'הסרת משתמש',
    confirm_prefix: 'האם ברצונך להסיר את',
    remove_from_segment: 'הסר לקוחות מסגמנט',
    selected_users: 'לקוחות שנבחרו',
  },
  edit_user_permissions: 'עריכת הרשאות משתמש',
  invitation_link: 'לינק הזמנה',
  users: 'משתמשים',
  invited: 'מוזמנים',
  add_user: 'הוספת משתמש',
  header: {
    home: `עמוד הבית`,
    logout: `התנתקות`,
    login: `התחברות`,
    register: `הרשמה`,
    create_event: `יצירת אירוע`,
    book_demo: ` לחצו כאן לקביעת דמו`,
    signin: `כניסה`,
    my_account: `אזור אישי`,
    subscriptions: `מנויים`,
    entry_pass: `כרטיסיות`,
    events: `אירועים`,
  },
  sales_table_head: {
    season_tickets: `מנויים`,
  },
  wellness: {
    registrants: 'נרשמים',
    registration: 'הרשמה',
  },
  "all-events": 'אירועים קרובים',
  event_types: {
    'trance-party': 'מסיבת טראנס',
    'techno-party': 'מסיבת טכנו',
    'electronic-party': 'מסיבה אלקטרונית',
    'culture': 'תרבות',
    'sport': 'ספורט',
    'business': 'עסקים',
    'lecturer': 'הרצאה',
    'education': 'חינוך',
    'charity': 'צדקה',
    'other': 'אחר',
    'wellness': 'בריאות',
    'music': 'מוזיקה'
  },
  pricing: {
    billing: 'בחיוב',
    entries: 'כניסות',
    purchase: 'לרכישה',
    used_entries: 'כניסות שנוצלו',
    out_of: 'מתוך',
    completed_charges: 'כמות חיובים שבוצעו',
    subscription_selected: 'מנוי זה נבחר',
    select_subscription: 'בחר מנוי זה',
    single_subscription_note: 'ניתן לעשות שימוש רק במנוי אחד בעת ההזמנה ',
    i_agree_to: 'אני מסכים/ה ל',
    terms_of_service: 'תנאי השימוש',
    terms_of_club_membership: 'תנאי החברות במועדון',
    and: '',
    privacy_policy: 'ומדיניות הפרטיות',
    must_agree_to_terms: 'עליך לאשר את תנאי השימוש ומדיניות הפרטיות כדי להמשיך',
    price_template: '₪{{price}}'
  },
  ticket: {
    row: 'שורה',
    seat: 'כסא',
    row_label: 'שורה - {{row}}',
    seat_label: 'כסא - {{seat}}',
    ticket_number: 'כרטיס כניסה #',
    order_number: 'מספר הזמנה',
    id_required: '(יש להציג את הכרטיס בליווי תעודה מזהה)',
    ticket_name: 'שם כרטיס',
    name: 'שם',
    event_date: 'תאריך האירוע',
    time: 'שעה',
    appointment_time: 'זמן התור',
    hall: 'אולם',
    ticket_type: 'סוג כרטיס',
    event_location: 'מיקום האירוע',
    notes: 'הערות',
    contact_email: 'יצירת קשר עם מנהלי האירוע',
    free_ticket: 'כרטיס חינם',
    price: 'מחיר',
    tickets: 'כרטיסים',
    ticket_refunded: 'כרטיס זה זוכה',
  },
  event_seats: {
    bar: 'בר',
    table: 'שולחן',
    row: 'שורה',
    seat_label: 'כיסא {{seat}}',
    parent_label: '{{type}} {{number}}',
    no_tickets: 'אין כרטיסים למכירה',
    ticket_prices: 'מחירי כרטיסים',
    coupon_note: 'ניתן להכניס קוד קופון לאחר בחירת המקומות'
  },
  chart: {
    total: 'סך הכל',
  },
  auth: {
    login: `התחברות`,
    new_password: `בחירת סיסמא חדשה`,
    approve: `אישור`,
    reset_password: `איפוס סיסמא`,
    send_reset_password: `שלח אימייל לאיפוס`,
    new_user: `עוד לא רשומים`,
    join_us: ` הצטרפו אלינו `,
    forgot_password: `שכחתי סיסמא`,
    login_title: `הי, ברוכים השבים!`,
    or: `או`,
    already_have_an_account: `כבר רשומים`,
    create_account: `צור חשבון`,
    wrong_credentials: `פרטים אינם נכונים`,
    been_invited: `הוזמנת ל`,
    already_exists_email: `האימייל כבר קיים`,
    invite_himself_error: `משתמש אינו יכול להזמין את עצמו`,
    reset_password_success: `הבקשה בוצעה בהצלחה, אנא בדקו את האימייל👍`,
    email: `אימייל`,
    passwords_must_match: `אנא וודאו שהסיסמאות זהות`,
    password_reset_success: `הסיסמא אופסה בהצלחה👍`,
    password: `סיסמא`,
    verify_password: `וִדּוּא סיסמא`,
    create_account_to_accept_invite: `על מנת לקבל את ההזמנה יש ליצור חשבון, אם כבר יש לך חשבון יש לבצע התחברות`,
    welcome_to_nimi: `ברוכים הבאים לנימי!`,
    company_name_english_only: `שם באנגלית בלבד`,
    company_name_required: `שם החברה הוא שדה חובה`,
    start_selling_title: `הרשמה  ומתחילים`,
    start_selling_description: ` בתום ההרשמה תוכלו להגדיר הפקות ליצור אירועים ולמכור כרטיסים`,
    start_selling_submit: `שלח`,
    click_here_to_login: `להתחברות לחצו כאן`,
    start_selling_success_message: `נרשמת בהצלחה`,
    start_selling_success_message_description: `הצוות שלנו יעבור על הפרטים לבנתיים אתם יכולים להתחיל ליצור אירועים`,
    bank_details: {
      gov_id_issue_date: `תאריך הנפקת תעודת זהות`,
      bank_code: `קוד בנק`,
      bank_branch: `מספר סניף בנק`,
      bank_account_number: `מספר חשבון בנק`,
      iban: `IBAN (אופציונלי)`,
      company_name: `שם חברה`,
      company_name_english_only: `באנגלית בלבד`,
      city: `עיר`,
      street: `רחוב`,
      house_number: `מספר בית`,
      business_type: `סוג עסק`,
      business_types: {
        private: `פרטי`,
        ltd: `חברה בע״מ`,
        exempt: `עוסק פטור`,
        non_profit: `Non Profit`,
        public: `חברה ציבורית`
      },
      finish: `סיום`
    }
  },
  onboarding: {
    steps: {
      user_details: `פרטי משתמש`,
      account_details: `פרטי חשבון`,
    },
  },
  forms: {
    validation: {
      numbers_only: `ספרות בלבד`,
      invalid_phone: `מספר טלפון אינו תקין`,
    },
    fields: {
      birth_date: `תאריך לידה`,
      gov_id: `תעודת זהות`,
      logo_url: `קישור ללוגו`,
      favicon_url: `קישור לfavicon`,
      main_domain: `דומיין ראשי`,
      distribution_id: `מזהה הפצה`,
    },
    features: {
      add_crm: `הוסף CRM`,
      add_producers_management: `הוסף ניהול מפיקים`,
      add_subscriptions_management: `הוסף ניהול מנויים`,
    },
    actions: {
      continue: `המשך`,
    },
  },
  dashboard: {
    customers_club: 'מועדון לקוחות',
    back_to_customers: 'חזרה ללקוחות',
    my_leads: 'הלידים שלי',
    no_leads: 'לא נמצאו לידים',
    analytics: {
      sellers: 'מוכרים',
      events: 'אירועים',
      purchases_count: 'כמות רכישות',
      total_purchases: 'סך כל הרכישות',
      commission_profit: 'רווח עמלות',
      amount_to_transfer: 'סכום להעביר'
    },
    error_close_and_try_again: 'ישנה תקלה, אנא סגרו את החלון ונסו שוב',
    create_new_order: 'צור הזמנה חדשה',
    my_documents: 'המסמכים שלי',
    bank_details_tab: 'פרטי בנק',
    invoices: 'חשבוניות',
    invoice_settings: {
      invoice_provider: 'ספק חשבוניות',
      invoice_provider_token: 'מפתח API',
      invoice_doc_type: 'סוג מסמך',
      should_send_invoice: 'שלח חשבונית אוטומטית',
      receipt: 'קבלה',
      invoice_receipt: 'חשבונית קבלה',
      token_helper_text: 'הזן את מפתח ה-API של iCount',
      provider_helper_text: 'לא ניתן לשנות את ספק החשבוניות',
      token_required: 'מפתח API נדרש כאשר שליחת חשבוניות מופעלת',
      token_help_title: 'איך להשיג את מפתח ה-API של iCount',
      token_help_description: 'עקוב אחר השלבים הבאים כדי לקבל את מפתח ה-API מ-iCount ולהתחיל לשלוח חשבוניות אוטומטית.',
      token_step1_title: 'העתק את קישור ההרשמה',
      token_step1_description: 'העתק את הקישור הזה: https://www.icount.co.il/r/?aff=968438',
      token_step2_title: 'צור חשבון',
      token_step2_description: 'לך לקישור וצור את חשבון ה-iCount שלך.',
      token_step3_title: 'קבל את מפתח ה-API',
      token_step3_description: 'נווט להגדרות החשבון בלוח הבקרה של iCount והעתק את מפתח ה-API שלך.',
      how_to_get_token: 'איך להשיג את המפתח?',
    },
    search: `חפש`,
    main: `ראשי`,
    selected: `נבחרו`,
    season_ticket_status: `סטטוס מנוי`,
    income: `הכנסות`,
    fee: `עמלה`,
    name: `שם`,
    system_fee: `עמלת מערכת`,
    tickets_quantity: `כמות כרטיסים`,
    average_tickets_per_order: `ממוצע כרטיסים להזמנה`,
    sales_percentage: `אחוזי מכירה`,
    seller_productions_details: 'פירוט הפקות למוכר',
    production_name: 'שם הפקה',
    number_of_events: 'מספר אירועים',
    number_of_purchases: 'מספר רכישות',
    total_production_purchases: 'סכום כלל הרכישות להפקה',
    total_production_purchases_after_refunds: 'סכום כלל הרכישות להפקה לאחר זיכויים',
    production_events_details: 'פירוט אירועים להפקה - {{0}}',
    event_name: 'שם אירוע',
    purchases_count: 'מספר רכישות',
    total_event_purchases: 'סכום כלל הרכישות לאירוע',
    total_event_purchases_after_refunds: 'סכום כלל הרכישות לאירוע לאחר זיכויים',
    commission_profit: 'רווח עמלות',
    amount_to_transfer_to_seller: 'סכום להעביר למוכר',
    money_transferred_to_seller: 'כסף הועבר למוכר',
    seller_name: 'שם מוכר',
    commission_percentage: 'אחוז עמלה',
    commission_profit_with_vat: 'רווח עמלות כולל מע״מ',
    commission_profit_net: 'רווח עמלות נקי',
    commission_profit_net_info: 'רווח עמלות לאחר הורדת עמלת מערכת - {{0}}%',
    amount_to_transfer_info: {
      title: 'סכום כלל הרכישות לאחר זיכויים פחות:',
      line1: '1. כמות רכישות כפול ',
      line2: '2. כמות זיכויים כפול 4.5 {{currency}} פלוס מעמ (5.265)',
      line3: '3. באירוע שהעמלה נלקחת מהמוכר ולא מהקונה - הפחתה של אחוז העמלה שנקבע מסך כלל הרכישות'
    },
    legal: {
      title: `הגדרת תקנון  `,
      terms_of_service: `תנאי שימוש`,
      privacy_policy: `מדיניות פרטיות`,
      terms_of_club_membership: `תנאי חברות במועדון`,
      submit: `שמור`,
      success: `הפרטים נשמרו בהצלחה`,
      error: `שגיאה בשמירת הפרטים`,
    },
    settings: {
      general: 'כללי',
      questions_for_buyers: 'שאלות לרוכשים',
      custom_questions: {
        add_new: 'הוספת שאלה חדשה',
        placeholder: 'שאלה נוספת',
        question_number: 'שאלה נוספת {{0}}',
        required_field: 'שדה חובה',
        field_type: 'סוג שדה',
        field_title: 'כותרת שדה',
        types: {
          free_text: 'טקסט חופשי',
          yes_no: 'כן או לא',
          date: 'תאריך'
        }
      }
    },
    events: {
      new_order: 'הזמנה חדשה',
      email_status_error: 'אנו שולחים מייל רק להזמנות בסטאטוס \'ממתין לאישור\' או \'מאושר\'. לא עבור סטאטוס \'{{0}}\'',
      event_type: 'סוג אירוע',
      choose_event_type: `בחרו סוג אירוע`,
      divided_order_approvable_not_allowed: `לא ניתן לאשר  הזמנה עם תשלום מפוצל לפני קבלת אישור תשלום `,
      handler_already_exists: `כתובת מקוצרת כבר קיימת נסו לבחור אחת שונה`,
      unauthorized: `למשתמש אין גישה לעמוד זה`,
      event: `אירוע `,
      new_event: `אירוע חדש`,
      default_event_notice: ' אירוע ברירת המחדל. כל אירוע חדש יירש את ההגדרות מאירוע זה.',
      default_event: 'אירוע ברירת מחדל',
      edit_event: `עריכת אירוע`,
      my_events: `האירועים שלי`,
      create_new_event: `יצירת אירוע חדש`,
      event_name: `שם האירוע`,
      copy_suffix: 'העתק',
      description: `תיאור`,
      content: `תוכן`,
      design: `עיצוב`,
      marketing: `שיווק`,
      embedding: `הטמעה`,
      embedding_explainer: `רוצים להוסיף משהו שאין לנו עדיין? ניתן להטמיע קוד כאן`,
      background_color: `צבע רקע`,
      buttons_color: `צבע כפתורים`,
      progress_bar_color: `צבע סרגל התקדמות`,
      privacy_policy_color: `צבע מדיניות פרטיות`,
      cover_photo: `תמונת רקע`,
      event_photo: `תמונת אירוע`,
      tickets: `כרטיסים`,
      seats_tickets: `כרטיסים למקומות מסומנים`,
      ticket_name: `שם כרטיס`,
      price: `מחיר`,
      amount: `כמות`,
      start_date: `תאריך התחלה`,
      end_date: `תאריך סיום`,
      location: `מיקום`,
      email_to_contact: `אימייל ליצירת קשר`,
      search: `חיפוש הזמנות (מספר הזמנה, שם, טלפון, שעה, תאריך)...`,
      search_events: `חיפוש אירועים...`,
      search_production_users: `חיפוש משתמשי הפקה...`,
      tickets_sale_status: `סטטוס מכירת כרטיסים`,
      edit: `עריכה`,
      view: `תצוגה`,
      start_hour: `שעת התחלה`,
      end_hour: `שעת סיום`,
      active_from_date: `זמין מתאריך`,
      inactive_from_date: `זמין עד תאריך`,
      active: `פעיל`,
      active_in_main_page: `פעיל בדף הראשי`,
      inactive: `לא פעיל`,
      new_ticket: `כרטיס חדש`,
      duplicate: `שיכפול`,
      set_as_default: `הגדר כברירת מחדל`,
      set_as_default_description: `אם תגדיר את האירוע הזה כברירת מחדל, כל האירועים החדשים ישתמשו בו כתבנית.`,
      remove: `הסר`,
      event_handler: `כתובת מקוצרת`,
      preview: `תצוגה`,
      create_event: `יצירת אירוע`,
      required_field: `שדה זה הוא חובה`,
      must_be_greater: `חייב להיות גדול מ- {{0}}`,
      must_be_less: `חייב להיות קטן מ- {{0}}`,
      min_length: 'אורך מינימלי הוא {{0}} תווים',
      max_length: 'אורך מקסימלי הוא {{0}} תווים',
      invalid_form: 'הטופס אינו תקין',
      english_letters_only: `אותיות באנגלית בלבד וללא רווחים`,
      invalid_email: `כתובת אימייל אינה תקינה`,
      invalid_url: 'פורמט URL אינו תקין',
      all_orders: `כל ההזמנות`,
      waiting_for_approval: `הזמנות שממתינות לאישור`,
      rejected_orders: `הזמנות שנדחו`,
      approved_orders: `הזמנות שאושרו`,
      refunded_orders: `הזמנות שזוכו`,
      ordered_after_limit_reached: `הזמנות מאוחרות`,
      name_already_exists: `קיים כרטיס עם אותו שם`,
      no_events: `אין אירועים`,
      crete_event: `יצירת אירוע`,
      facebook_page: `עמוד פייסבוק`,
      facebook_pixel: `פייסבוק פיקסל`,
      facebook_pixel_explainer: `         נא להזין את ה ID בלבד  `,
      facebook_pixel_explainer_link: ` מה זה פייסבוק פיקסל?`,
      facebook_pixel_explainer_link_2: ` איך ליצור פייסבוק פיקסל?`,
      google_analytics_id: `גוגל אנליטיקס`,
      google_analytics_id_explainer: `        נא להזין את ה ID בלבד  `,
      google_analytics_id_explainer_link: `     מה זה גוגל אנליטיקס?`,
      google_analytics_id_explainer_link_2: ` איך ליצור מזהה גוגל אנליטיקס?`,
      orders: `הזמנות`,
      event_settings: `הגדרות אירוע`,
      order_name: `שם מזמין`,
      order_number: `מספר הזמנה`,
      order_status: `סטאטוס הזמנה`,
      user_event_status: `סטאטוס רוכש`,
      ticket_page_link: `לינק לכרטיס`,
      split_payment_link: `לינק לתשלום מחולק`,
      order_tickets_amount: `כמות כרטיסים`,
      order_tickets_quantity: `כמות כל הכרטיסים`,
      order_total_price: `סכום הזמנה`,
      coupon: `קופון`,
      season_ticket: `מנוי`,
      order_date: `תאריך ביצוע הזמנה`,
      order_details: `פרטי הזמנה`,
      event_user_full_name: `שם מלא`,
      seat: `מושב`,
      event_user_social: `קישור לסושיאל`,
      event_user_gender: `מין`,
      event_user_age: `גיל`,
      event_user_phone: `טלפון`,
      event_user_email: `אימייל`,
      event_user_ticket_name: `שם כרטיס`,
      event_user_paid_price: `סכום`,
      user_scanned: `כרטיס נסרק`,
      order_refunded: `זיכוי מלא`,
      order_fully_refunded: `זיכוי מלא`,
      order_partial_refunded: `זיכוי חלקי`,
      cancellation_without_refund: `ביטול ללא זיכוי`,
      order_approved: `מאושר`,
      order_pending: `ממתין לאישור`,
      divide_order_pending: `תשלום מפוצל נוצר`,
      divide_order_active: `תשלום מפוצל בתהליך`,
      divide_order_complete: `תשלום מפוצל הושלם`,
      divide_order_failed: `תשלום מפוצל נכשל`,
      order_rejected: `ההזמנה נדחתה`,
      approve_order: `אישור הזמנה`,
      refund_order: `זיכוי הזמנה`,
      reject_order: `דחיית הזמנה`,
      open_whatsapp: `פתח בווטסאפ`,
      open_email: `פתח באימייל`,
      edit_details: `עריכת פרטים`,
      approve: `אישור`,
      reject: `לדחות`,
      cancel: `ביטול`,
      should_approve_order: `האם ברצונך לאשר את ההזמנה?`,
      should_reject_order: `האם ברצונך לדחות את ההזמנה?`,
      update_event: `עדכון אירוע`,
      order_approved_successfully: `ההזמנה אושרה בהצלחה!`,
      order_refunded_successfully: `ההזמנה זוכתה בהצלחה!`,
      no_data: `אין נתונים`,
      update: `עדכן`,
      copy: `העתק`,
      copied: `הועתק!`,
      question: `שאלה`,
      answer: `תשובה`,
      all_sales: `נתוני מכירות`,
      sales_per_ticket: `נתוני מכירות עבור כרטיס`,
      paid: `שולם`,
      total_approved: ` סה״כ כרטיסים שנקנו ומאושרים להגעה`,
      total_paid: ` סה״כ כרטיסים שנרכשו  `,
      total_refunded: ` סה״כ כרטיסים שזוכו`,
      total_coupons_used: ` סה״כ כרטיסים שנרכשו באמצעות קופון`,
      total_season_tickets_used: ` סה״כ כרטיסים שנרכשו באמצעות מנוי`,
      available: `זמין`,
      refunded: `זוכה`,
      tickets_sold: `כרטיסים נמכרו`,
      all_tickets: `כל הכרטיסים`,
      sold_out: `כל הכרטיסים נמכרו`,
      must_have_entering_q: `חייב שאלת כניסה`,
      active_event: `אירוע פעיל`,
      resend_mail: `שלח שוב מייל`,
      show_charges: `פרטי עסקה`,
      show_splited_charges: `עסקה מפוצלת`,
      send: `שלח`,
      should_resend_mail: `שלח מייל ל`,
      close: `סגור`,
      should_manual_approve: `חייב אישור ידני עבור כל הזמנה`,
      most_close_event: `הקרוב ביותר`,
      most_far_event: `הרחוק ביותר`,
      archive_newest_first: `חדש תחילה`,
      archive_oldest_first: `ישן תחילה`,
      checked_in: `נסרק`,
      not_checked_in: `עדייו לא נסרק`,
      apply_check_in: `ביצוע סריקה ידנית`,
      email_resent: `אימייל נשלח!`,
      create_new_link: `לינק חדש`,
      delete_links: `מחיקת לינקים`,
      delete: `מחיקה`,
      link: `לינק`,
      change_status: `שינוי סטאטוס`,
      set_inactive: `הגדר כלא פעיל`,
      set_active: `הגדר כפעיל`,
      all_events: `כל האירועים`,
      future_events: `אירועים עתידים`,
      archive_events: `אירועי עבר`,
      past: `עבר`,
      send_refund: `שלח זיכוי`,
      charge_status_completed: `חויב בהצלחה`,
      charge_status_refund: `זיכוי מלא`,
      charge_status_partial_refund: `זיכוי חלקי`,
      date: `תאריך`,
      card_mask: `מספר כרטיס`,
      buyer_email: `אימייל רוכש`,
      buyer_name: `שם רוכש`,
      buyer_phone: `טלפון רוכש`,
      card_brand: `סוג כרטיס`,
      charge_type: `סוג עסקה`,
      sale_status: `סטטוס עסקה`,
      charge_sum: `סכום`,
      invoice: `חשבונית`,
      view_invoice: `צפייה בחשבונית`,
      charge_external_code: `מספר עסקה`,
      buyer_key: `מפתח רוכש`,
      please_fill_required_fields: `אנא מלא את כל השדות הנדרשים`,
      please_enter_valid_amount: `אנא הכנס סכום תקין`,
      error_creating_charge: `שגיאה ביצירת חיוב`,
      creating: `יוצר...`,
      external_transaction_auth_number: `מספר אישור סליקה`,
      max_capacity_explainer: `מקסימום כרטיסים שניתן למכור לארוע זה`,
      max_capacity: `קיבולת מקסימלית`,
      error_uploading_image: `שגיאה בהעלאת תמונה`,
      copy_event_link: `העתק לינק אירוע`,
      copy_scanner_link: `העתק לינק לסורק`,
      free_ticket_helper: `לכרטיס חינם, הכניסו ״0״`,
      min_tickets_helper: `מספר כרטיסים מינימאלי בהזמנה אחת`,
      min_tickets_label: `כמות מינימאלית להזמנה`,
      max_tickets_helper: `מספר כרטיסים מקסימלי בהזמנה אחת`,
      max_tickets_label: `כמות מקסימלית להזמנה`,
      ticket_order_helper: `מיקום הצגת הכרטיס בטבלת הרכישה`,
      ticket_order_label: `מיקום הכרטיס`,
      seats_ticket_tooltip: `אפשר מכירת כרטיסים למקומות מסומנים עבור האירוע`,
      event_name_min_length: `שם האירוע חייב להכיל לפחות 4 תוים`,
      event_name_letters_only: `שם האירוע חייב להכיל אותיות`,
      no_tickets_for_sale: `- אין כרטיסים למכירה -`,
      tickets_sold_out: `לצערנו אזלו הכרטיסים`,
      no_waiting_list: `באירוע זה אין רשימות המתנה (אל דאגה הכרטיס לא חוייב)`,
      season_ticket_entry_pass: `כרטיסייה`,
      entry_pass_usage: `השתמשת ב {{0}} מתוך {{1}}`,
      available_entries: `כניסות שניתן לממש באירוע זה`,
      no_entries_left: `לא נותרו לך כניסות למימוש באירוע זה`,
      refresh_page_error: `ישנה בעיה, אנא נסו לרענן את העמוד`,
      no_access_to_edit: 'אין גישה לעריכת האירוע',
      form_validation_error: 'טופס אינו תקין, אנא בדקו את השדות',
      income_after_credits_and_fee: "הכנסות אחרי זיכויים ועמלת מערכת",
      income_data: "נתוני הכנסות",
      ticket_data: 'נתוני כרטיסים',
      buyer_data: 'נתוני רוכשים',
      commission_profit: 'רווח עמלות',
      amount_to_transfer_to_seller: 'סכום להעביר למוכר',
      field_updated_successfully: 'שדה עודכן בהצלחה!',
      events_of: 'האירועים של',
      no_access_to_event_details: 'אין גישה לצפות בפרטי האירוע',
      duplicate_event: 'שיכפול אירוע',
      duplicate_event_instructions: 'על מנת לשכפל את האירוע יש לבחור כתובת מקוצרת חדשה',
      tickets_return_caption: 'הכרטיסים המסומנים יוחזרו למאגר הכרטיסים למכירה',
      ticket_cancelled_no_refund: 'בוטל ללא החזר',
      fab_settings: 'הגדרות כפתור צף',
      show_fab: 'הצג כפתור צף',
      show_fab_note: 'אפשר כפתור פעולה צף בעמוד האירוע',
      fab_text: 'טקסט כפתור צף',
      fab_text_helper: 'טקסט שיוצג על כפתור הפעולה הצף'
    },
    sms_campaign: {
      file_extension_error: `סוג קובץ לא תקין`,
      name: `שם הקמפיין`,
      content: `תוכן הקמפיין`,
      phones: `מספרי טלפון`,
      edit: `ערוך`,
      properties: `מאפיינים`,
      recipients: `נמענים`,
      summary: `סיכום`,
      upload_phone_numbers_from_excel_file: `העלה מספרי טלפון מתוך אקסל`,
      sms_upload_support_files: '(csv, xslx)',
      upload_phones_numbers_manually: `העלה מספרי טלפון ידנית`,
      start_create_sms_campaign: 'התחל קמפיין של סמסים',
      sms_alert_duplicate_phone_numbers_are_not_allowed: 'וודא כי כל המספרים שונים זה מזה',
      sms_alert_please_provide_all_phone_numbers: 'וודא שאין תאים של מספרים ריקים',
      sms_alert_make_sure_that_no_number_has_not_been_added_to_the_list: 'וודא שאין מספרים שלא התווספו לרשימה או תאים ריקים',
      sms_alert_invalid_israeli_phone_numbers_provided: 'וודא כי המספרים הם בפורמט ישראל',
      sms_alert_chars_must_be_less_then_1000_characters: 'וודא כי הסמס לא מכיל יותר מ1000 תווים',
      sms_alert_add_phone_number: 'וודא כי הוספת את המספר: ',
      sms_campaign_content: 'תוכן הקמפיין',
      sms_campaign_name: 'שם הקמפיין',
      sms_campaign_counter_number: 'כמות שליחות',
      sms_campaign_created_at: 'תאריך שליחת הסמס',
      sms_excel_upload_example: 'דוגמאות לקבצי אקסל להעלאה',
      sms_excel_upload_first_file: 'דוגמא 1',
      sms_excel_upload_second_file: 'דוגמא 2',
      sms_excel_upload_third_file: 'דוגמא 2',
      sms_unable_to_add_phone_numbers: 'לא ניתן להוסיף מספרים נוספים'
    },
    stats: {
      gender_distribution: 'חלוקה על פי מגדר',
      average_age: 'גיל ממוצע',
      scanned_tickets: 'כרטיסים נסרקו',
      age_distribution: 'חלוקה על פי גילאים',
      age: 'גיל',
      count: 'כמות'
    },
    profile_settings: {
      font_upload_error: 'שגיאה בהעלאת קובץ הגופן',
      handler_required_notice: 'שימו לב! כדי לקבל את הלינק של עמוד המוכר שלכם יש להוסיף תחילה את הכתובת המקוצרת בשדה למטה',
      seller_page_link: 'קישור לעמוד מוכר',
      seller_scanner_page_link: 'קישור לסורק מנויים',
      background_image: 'תמונת רקע',
      background_image_mobile: 'תמונת רקע (מובייל)',
      profile_image: 'תמונת פרופיל',
      profile_image_is_logo: 'השתמש בתמונת הפרופיל כלוגו',
      name: 'שם',
      short_url: 'כתובת מקוצרת',
      short_url_placeholder: 'כתובת_מקוצרת',
      settings: 'הגדרות',
      show_header: 'הצג סרגל עליון עם התחברות לאזור האישי',
      allow_subscriptions: 'אפשר מנויים',
      hide_login_link: 'הסתר קישור אזור אישי',
      hide_signup_link: 'הסתר קישור להרשמה',
      hide_subscription_link: 'הסתר קישור לרכישת מנויים',
      hide_entry_pass_link: 'הסתר קישור לרכישת כרטיסיות',
      hide_title: 'הסתר כותרת עמוד המוכר',
      season_ticket_grants_entrance: 'כניסת מנויים בעזרת קוד QR',
      seller_page_design: 'עיצוב עמוד המוכר',
      seller_page_event_design: 'עיצוב עמוד אירועים',
      seller_page_event_design_helper: 'שימו לב שניתן להגדיר צבע גם כשקוף או חצי שקוף',
      image_overlay: ' פילטר צבע על תמונת אירוע',
      event_layout: 'סידור אירועים',
      default_layout: 'ברירת מחדל',
      masonry_layout: 'תצוגת לבנים',
      event_filter: 'סינון אירועים',
      event_filter_ui_element: 'סוג ממשק לסינון אירועים',
      no_filter: 'ללא סינון',
      by_production: 'לפי הפקה',
      by_event_type: 'לפי סוג אירוע',
      dropdown: 'תפריט נפתח',
      tabs: 'לשוניות',
      buttons: 'כפתורים',
      button_group: 'קבוצת כפתורים',
      event_filter_default: 'ערך סינון ברירת מחדל',
      event_filter_default_helper: 'הגדר ערך ברירת מחדל לסינון אירועים בעת טעינת העמוד',
      event_filter_default_placeholder: 'למשל, שם-הפקה או סוג-אירוע',
      event_text_color: 'צבע טקסט אירוע',
      event_label_color: 'צבע תווית אירוע',
      event_label_position: 'מיקום תווית',
      on_image: 'על התמונה',
      under_image: 'מתחת לתמונה',
      centered: 'ממורכז',
      space_between: 'מרווח',
      event_label_content: 'תוכן תווית אירוע',
      event_label_content_helper: 'בחר איזה מידע להציג בתווית האירוע',
      title: 'כותרת',
      date: 'תאריך',
      day: 'יום',
      hour: 'שעה',
      date_day_hour: 'תאריך יום ושעה בתור',
      date_day_hour_line: 'תאריך יום ושעה בשורה אחת',
      participants: 'משתתפים',
      participants_bar: 'סרגל משתתפים',
      'participants-bar': 'סרגל משתתפים',
      waiting_list: 'רשימת המתנה',
      'waiting-list': 'רשימת המתנה',
      trainer: 'מאמן',
      show_entrance_code: 'הצג קוד כניסה',
      entrance_code_modal_title: 'קוד כניסה',
      entrance_code_description: 'הצג קוד QR זה בכניסה.'
    },
    credits: "זיכויים",
    total: "סה״כ",
    create_monthly_report: "יצירת דוח חודשי",
    download_data: "הורדת נתונים",
    club_member: "חבר המועדון",
    total_income_from_tickets: "סך כל ההכנסות מרכישות הכרטיסים",
    my_profile: "הפרופיל שלי",
    seller_page: "עמוד מוכר",
    total_credits_made: "סך כל הזיכויים שבוצעו",
    amount_details: "פירוט הסכום",
    income_after_credits_and_fee: "הכנסות אחרי זיכויים ועמלת מערכת",
    production: {
      production_settings: 'הגדרות הפקה',
      settings_explainer: 'הגדרות אלו יהיו ברירת המחדל לכל אירוע חדש שיווצר תחת הפקה זו',
    },
  },
  lead: {
    add_new: 'הוסף ליד חדש',
    created_success: 'ליד נוצר בהצלחה',
    status_updated_success: 'סטטוס הליד עודכן בהצלחה',
    details: 'פרטי ליד',
    additional_info: 'מידע נוסף',
    status: 'סטטוס',
    origin: 'מקור',
    status_initial: 'ראשוני',
    status_cold: 'קר',
    status_warm: 'חם',
    status_approved: 'מאושר לרכישת מנוי',
    status_paying: 'חבר משלם',
  },
  my_leads_page: {
    title: 'הלידים שלי',
    no_leads_found: 'לא נמצאו לידים',
    add_new_lead: 'הוסף ליד חדש',
    lead_created_success: 'ליד נוצר בהצלחה',
    lead_status_updated_success: 'סטטוס הליד עודכן בהצלחה',
    lead_details: 'פרטי ליד',
    additional_information: 'מידע נוסף',
    lead_status: 'סטטוס ליד',
    lead_origin: 'מקור ליד',
    status_initial: 'ראשוני',
    status_cold: 'קר',
    status_warm: 'חם',
    status_approved: 'מאושר לרכישת מנוי',
    status_paying: 'חבר משלם',
    table_headers: {
      first_name: 'שם פרטי',
      email: 'אימייל',
      phone: 'טלפון',
      date: 'תאריך',
      origin: 'מקור',
      status: 'סטטוס'
    },
    form_labels: {
      first_name: 'שם פרטי',
      last_name: 'שם משפחה',
      email: 'אימייל',
      phone: 'טלפון',
      birth_date: 'תאריך לידה',
      gender: 'מין',
      lead_status: 'סטטוס ליד',
      lead_origin: 'מקור ליד'
    },
    gender_options: {
      male: 'זכר',
      female: 'נקבה'
    },
    status_options: {
      initial: 'ראשוני',
      cold: 'קר',
      warm: 'חם'
    },
    actions: {
      submit: 'אישור',
      cancel: 'ביטול',
      close: 'סגור',
      approve: 'אשר'
    },
    validation: {
      required_field: 'שדה זה הוא חובה'
    }
  },
  snackbar: {
    coupon_deleted_successfully: `הקופון נמחק בהצלחה!`,
    sub_account_updated_successfully: `הפקה עודכנה בהצלחה!`,
    sub_account_created_successfully: `הפקה נוצרה בהצלחה!`,
    event_created_successfully: `אירוע נוצר בהצלחה!`,
    event_updated_successfully: `אירוע עודכן בהצלחה!`,
    files_updated_successfully: 'קבצים עודכנו בהצלחה!',
    details_updated_successfully: `פרטים עודכנו בהצלחה!`,
    order_rejected: `ההזמנה נדחתה`,
    coupon_created_successfully: `קופון נוצר בהצלחה!`,
    coupon_updated_successfully: `קופון עודכן בהצלחה!`,
    season_ticket_discount_created_successfully: `הנחה נוצרה בהצלחה!`,
    season_ticket_discount_updated_successfully: `הנחה עודכנה בהצלחה!`,
    link_created_successfully: `לינק נוצר בהצלחה!`,
    link_updated_successfully: `לינק עודכנו בהצלחה!`,
    links_deleted_successfully: `לינקים נמחקו בהצלחה!`,
    invited_successfully: `משתמש הוזמן בהצלחה!`,
    collaborate_updated_successfully: `משתמש עודכן בהצלחה!`,
    event_handler_exists: `כתובת מקוצרת כבר קיימת`,
    refund_card_error: `ישנה בעיה עם חברת האשראי, אנא נסו שוב מאוחר יותר`,
    marketplace_account_created_successfully: `מוכר נוצר בהצלחה`,
    marketplace_account_updated_successfully: `מוכר עודכן בהצלחה`,
    tickets_price_updated_successfully: `מחירי הכרטיסים עודכנו בהצלחה!`,
    page_updated_successfully: `עמוד עודכן בהצלחה!`,
    event_settings_updated_successfully: `הגדרות האירוע עודכנו בהצלחה!`,
    price_level_removed_successfully: `רמת מחיר הוסרה בהצלחה!`,
    subscription_applied_successfully: 'מנוי מומש בהצלחה!',
    coupon_applied_successfully: 'קופון הופעל בהצלחה!',
    seller_updated_successfully: 'מוכר עודכן בהצלחה',
    no_changes_made: 'לא בוצעו שינויים'
  },
  event_page: {
    add_to_calendar: `הוספה ליומן`,
    chosen_ticket: `בחירת כרטיסים`,
    enter_details: `מילוי פרטים`,
    payment: `תשלום`,
    order_summary: `סיכום הזמנה`,
    total_to_pay: `סה״כ לתשלום`,
    payment_provider: `ספק תשלום`,
    male: `זכר`,
    female: `נקבה`,
    other: `אחר`,
    pay: `לתשלום`,
    complete_order: `סיום הזמנה`,
    split_order: `שלם עם חברים `,
    order_details: `פרטי המזמין`,
    ticket: `כרטיס`,
    first_name: `שם פרטי`,
    last_name: `שם משפחה`,
    phone: `טלפון`,
    email: `אימייל`,
    invalid_email: `אימייל אינו תקין`,
    invalid_phone: `מספר טלפון אינו תקין`,
    invalid_social_link: `קישור אינו תקין`,
    invalid_date: `תאריך אינו תקין (DD/MM/YYYY)`,
    birth_date: `תאריך לידה`,
    social_link: `קישור לעמוד אינסטגרם או פייסבוק`,
    credit_card_number: `מספר אשראי`,
    credit_card_date: `תוקף אשראי`,
    credit_card_cvv: `שלוש ספרות בגב הכרטיס`,
    credit_card_holder_name: `שם בעל הכרטיס`,
    pay_now: `תשלום`,
    required_field: `שדה זה הוא חובה`,
    to_order: `להזמנה`,
    sold_out: `אזל`,
    please_choose_tickets: `אנא בחרו כרטיסים`,
    season_ticket_discount_will_appear_after_choosing_tickets: `*הנחת המנוי תופיע לאחר בחירת הכרטיס `,
    gender: `מין`,
    ticket_name: `שם כרטיס`,
    ticket_price: `מחיר`,
    season_ticket_discount_ticket_price: `מחיר למנויים`,
    ticket_amount: `כמות`,
    already_exists_email: `אנא מלאו אימייל שונה עבור כל כרטיס`,
    already_exists_phone: `אנא מלאו טלפון שונה עבור כל כרטיס`,
    already_exists_social: `אנא מלאו קישור שונה עבור כל כרטיס`,
    card_holder_first_name: `שם פרטי של בעל הכרטיס`,
    card_holder_last_name: `שם משפחה של בעל הכרטיס`,
    cvv_number: `ספרות בגב הכרטיס`,
    card_number: `מספר כרטיס`,
    card_date: `תוקף כרטיס`,
    social_id_card_number: `מספר תעודת זהות`,
    generic_payment_form_error: `ישנה בעיה בטופס תשלום`,
    payment_rush_error_one: `המערכת מטפלת בבקשות קודמות, אנא המתינו`,
    payment_rush_error_two: `שניות ונסו שוב`,
    invalid_card_number: `מספר כרטיס אשראי אינו תקין`,
    invalid_card_cvv: `ספרות בגב הכרטיס אינן תקינות`,
    refusal_payment: `סירוב על ידי חברת האשראי, אנא נסו כרטיס אחר`,
    invalid_card_expiry: `תוקף כרטיס אינו תקין`,
    payment_invalid_phone_number: `נראה שיש בעיה עם מספר הטלפון שהוזן, אנא חזרו לשלב הקודם ובדקו את הפרטים`,
    payment_invalid_email: `נראה שיש בעיה עם האימייל שהוזן, אנא חזרו לשלב הקודם ובדקו את הפרטים`,
    seats_already_taken: `מצטערים, המושבים שנבחרו כבר נתפסו, נסו לבחר מושבים אחרים במקום `,
    missing_fields: `אנא ודאו שמילאתם את כל הפרטים`,
    order_success: `ההזמנה בוצעה בהצלחה!`,
    order_created_limit_reached: `הזמנה מחכה לאישור של מנהלי האירוע`,
    order_created_waiting_list: `לצערנו אזלו הכרטיסים  במהלך הקנייה. אבל… נכנסתם לרשימת המתנה`,
    new_order: `לביצוע הזמנה נוספת`,
    order_waiting_for_approval: `ההזמנה מחכה לאישור של מנהלי האירוע...`,
    ticket_by_mail: `פרטי ההזמנה ישלחו במייל`,
    form_error: `ישנה בעיה בטופס`,
    is_approved: `מאושר`,
    supported_payment_method: ` אמצעי תשלום נתמכים`,
    safari_private_mode_message: `לצערנו, לא ניתן לבצע הזמנות בדפדפן safari כאשר גולשים בprivate mode, אנא עברו למצב רגיל או בחרו דפדפן אחר`,
    error_fallback: {
      title: ` אופס! משהו השתבש`,
      subtitle: `הצוות שלנו קיבל את המידע, ויטפל בבעיה בהקדם האפשרי`,
      action_btn_msg: `נסו שוב`,
    },
    error: {
      generic: 'משהו השתבש בטעינת האירוע. אנא נסו שוב.',
      network: 'שגיאת רשת. אנא בדקו את החיבור שלכם ונסו שוב.',
      timeout: 'הבקשה פגה. אנא נסו שוב.',
    },
    account_not_found_with_handler: {
      title: 'החשבון לא נמצא',
      subtitle: 'החשבון שאתם מחפשים אינו קיים או הוסר.',
    },
    event_not_found_handler: {
      title: 'האירוע לא נמצא',
      subtitle: 'האירוע שאתם מחפשים אינו קיים או הוסר.',
    },
    event_disabled: {
      title: 'האירוע אינו זמין',
      subtitle: 'אירוע זה אינו זמין כרגע או הושבת על ידי המארגן.',
    },
    not_found: {
      go_home: 'חזרה',
    },
    block_purchase: {
      title: `סליחה, היינו חייבים לעצור את ההזמנה הזאת`,
      action_btn_msg: `צור קשר לתמיכה`
    },
    payme_error: {
      title: `היתה בעיה בסליקת האשראי`,
      subtitle: `במידה והשתמשתם בכרטיסי אשראי מסוג דיינרס או אמריקן אקספרסס נסו להשתמש באמצעי תשלום חלופי`,
      action_btn_msg: `נסו שוב`,
    },
    members_only: {
      title: `אירוע למנויים בלבד`,
      message: "אם יש לכם מנוי נא ודאו שאתם מחוברים",
      cta: "התחברות",

    },
    not_enough_tickets_title: `לצערנו נותרו פחות כרטיסים מהכמות שנבחרה`,
    not_enough_tickets_subtitle: `נסו לבחור כמות כרטיסים קטנה יותר`,
    coupon_not_found: 'קופון לא נמצא או לא ניתן לשימוש יותר',
    must_accept_terms: 'חובה לאשר את התקנון לפני ביצוע רכישה',
    fixed_price_template: 'מחיר קבוע - ₪{{amount}}',
    purchase_fee: 'עמלת רכישה',
    coupon_code: 'קוד קופון',
    go_to_tickets_selection: 'לבחירת כרטיסים',
    go_to_seats_selection: 'לבחירת מושבים',
    terms_consent: {
      i_have_read: 'קראתי את',
      terms_of_service: 'תנאי השימוש',
      and_i_agree: 'ואני מסכים',
      to_terms_and_cancellation_policy: 'לתנאים ולמדיניות ביטולים'
    },
    pending_approval_account_cannot_sell_tickets: 'המוכר ממתין לאישור ואינו יכול לקבל תשלומים בשלב זה נסה שוב מאוחר יותר ',
    preloaded_user_data: 'בעל המנוי',
    phone_already_exist_for_this_seller: 'הטלפון כבר קיים עבור המוכר הזה',
  },
  app: `דשבורד ראשי`,
  general: {
    activate: 'הפעל',
    yes: 'כן',
    no: 'לא',
    enabled: 'מופעל',
    disabled: 'מושבת',
    open: 'פתוח',
    closed: 'סגור',
    save: 'שמור',
    cancel: 'ביטול',
    minutes: 'דקות',
    event_revenues: 'הכנסות מאירועים',
    seller_revenues: 'הכנסות ממוכרים',
    subscription_revenues: 'הכנסות ממנויים',
    welcome_male: 'ברוך הבא',
    welcome_female: 'ברוכה הבאה',
    welcome_description: 'כאן תוכלו לראות מבט כללי על נתוני המערכת',
    total_customers_this_year: 'סך כל הלקוחות מתחילת השנה',
    total_revenues_this_year: 'ההכנסות מתחילת השנה',
    total_events_this_year: 'סך כל האירועים מתחילת השנה',
    monthly_revenues: 'הכנסות פר חודש',
    recent_orders: 'הזמנות אחרונות',
    order_number: 'מספר הזמנה',
    event_name: 'שם אירוע',
    price: 'מחיר',
    status: 'סטאטוס',
    date: 'תאריך',
    recent_customers: 'לקוחות אחרונים',
    today: 'היום',
    this_week: 'השבוע',
    since_month_start: 'מתחילת החודש',
    since_quarter_start: 'מתחילת הרבעון',
    since_year_start: 'מתחילת השנה',
    compared_to_year_average: 'ביחס לממוצע מתחילת השנה',
    new_subscribers: 'מנויים חדשים',
    waiting_for_approval: 'ממתין לאישור',
    order_rejected: 'ההזמנה נדחתה',
    order_approved: 'מאושר',
    order_cancelled: 'בוטל',
    order_refunded: 'זוכה',
    churned_subscribers: 'מנויים שבוטלו',
  },
  event_management: `ניהול אירוע`,
  event_sale_stats: `נתוני מכירות`,
  edit_event: `עריכת אירוע`,
  event_settings: {
    general: 'כללי',
    questions_for_buyers: 'שאלות לרוכשים',
    integrations: 'אינטגרציות',
    time_slots: 'חלוקת זמנים',
    enable_time_slots: 'הפעל הזמנות לפי חלוקת זמנים',
    time_slots_info: 'אפשר ללקוחות להזמין כרטיסים לטווחי זמן מסוימים',
    time_slots_help: 'הגדר שעות פעילות שונות לכל יום בשבוע ותאריכים מיוחדים',
    weekly_schedule: 'לוח זמנים שבועי',
    opening_time: 'שעת פתיחה',
    closing_time: 'שעת סגירה',
    slot_duration: 'משך חלונית זמן (דקות)',
    slot_capacity: 'קיבולת חלונית זמן',
    break_times: 'זמני הפסקה',
    add_break: 'הוסף הפסקה',
    no_break_times: 'אין זמני הפסקה מוגדרים',
    break_label: 'תיאור הפסקה',
    break_start: 'תחילת הפסקה',
    break_end: 'סוף הפסקה',
    special_dates: 'תאריכים מיוחדים',
    dates_configured: 'תאריכים מוגדרים',
    add_special_date: 'הוסף תאריך מיוחד',
    no_special_dates: 'אין תאריכים מיוחדים מוגדרים',
    date: 'תאריך',
    special_schedule: 'לוח זמנים מיוחד',
    closed_day: 'יום סגור',
    reason: 'סיבה',
    booking_window: 'חלון הזמנה',
    advance_booking_days: 'ימים מראש להזמנה',
    advance_booking_help: 'כמה ימים מראש אפשר להזמין',
    cutoff_minutes: 'דקות לחיתוך הזמנה',
    cutoff_help: 'כמה דקות לפני תחילת חלונית הזמן לא ניתן להזמין',
    live_preview: 'תצוגה מקדימה חיה',
    enable_preview_message: 'הפעל חלוקת זמנים כדי לראות תצוגה מקדימה',
    time_slots_statistics: 'סטטיסטיקות חלוקת זמנים',
    total_slots_per_day: 'סה"כ חלוניות זמן ביום',
    total_capacity_per_day: 'קיבולת כוללת ביום',
    preview_day: 'יום לתצוגה מקדימה',
    choose_date_preview: 'בחרו תאריך לתצוגה מקדימה',
    selected_day: 'יום נבחר',
    quick_day_selection: 'בחירה מהירה של יום',
    weekly_summary: 'סיכום שבועי',
    active_days: 'ימים פעילים',
    weekly_slots: 'חלוניות זמן שבועיות',
    weekly_capacity: 'קיבולת שבועית',
    spots: 'מקומות',
    day: 'יום',
    status: 'סטטוס',
    hours: 'שעות',
    duration: 'משך זמן',
    capacity: 'קיבולת',
    slots: 'חלוניות זמן',
    schedule: 'לוח זמנים',
    break_periods: 'זמני הפסקה',
    day_capacity: 'קיבולת יומית',
    available_slots: 'חלוניות זמן זמינות',
    time_format_help: 'פורמט: HH:MM (24 שעות)',
    slot_duration_minutes: 'משך חלונית זמן (דקות)',
    duration_help: 'משך כל חלונית זמן',
    capacity_help: 'מספר מקסימלי של הזמנות לחלונית זמן',
    capacity_per_slot: 'קיבולת לחלונית זמן',
    enable_this_day: 'הפעל יום זה',
    daily_capacity: 'קיבולת יומית',
    total_slots: 'סה"כ חלוניות זמן',
    operating_hours: 'שעות פעילות',
    preview: 'תצוגה מקדימה',
    day_statistics: 'סטטיסטיקות יומיות',
    hours_total: 'שעות סה"כ',
    breaks_configured: 'הפסקות מוגדרות',
    no_breaks: 'לא הוגדרו זמני הפסקה',
    revenue_potential: 'פוטנציאל הכנסות',
    max_bookings_per_day: 'מקסימום הזמנות ליום',
    productive_hours: 'שעות פרודוקטיביות',
    break_hours: 'שעות הפסקה',
    bookings: 'הזמנות',
    day_not_available: '{{day}} אינו זמין להזמנה',
    no_slots_today: 'אין חלוניות זמן זמינות לתאריך זה',
    slots_available: 'חלוניות זמן זמינות',
  },
  seats_chart: {
    title: 'מפת מושבים',
    no_seats_chart: 'אין מפת מושבים',
    select_seats_chart: 'בחירת מפת מושבים',
    cant_change_after_orders: 'לא ניתן לשנות מפת מושבים לאחר שבוצעו רכישות',
    validation_error: 'ישנה בעיה במפת המושבים',
    choose: 'בחירה',
    edit_categories: {
      title: 'עריכת קטגוריות',
      subtitle: 'עריכת קטגוריות הושבה לאירוע זה בלבד',
      category_name: 'שם קטגוריה',
      category_color: 'צבע קטגוריה',
      accessibility: 'נגישות',
      accessibility_tooltip: 'סמן קטגוריה זו כנגישה לאנשים עם מוגבלויות',
      remove: 'הסר',
      remove_tooltip: 'הסרת קטגוריה זו',
      cant_remove_after_orders: 'לא ניתן להסיר קטגוריה לאחר שנמכרו כרטיסים',
      add_category: 'הוסף קטגוריה',
      save: 'שמור',
      fill_all_fields: 'אנא מלא את כל השדות',
      unique_names_required: 'אנא ודא שכל קטגוריה בעלת שם ייחודי.',
      update_success: 'הקטגוריות עודכנו בהצלחה',
      update_error: 'שגיאה בעדכון הקטגוריות'
    },
    price_levels: {
      default: 'רגיל',
      enter_name: 'נא להזין שם לרמת המחיר',
      names_must_be_unique: 'שמות רמות המחיר חייבים להיות שונים',
      price_level: 'רמת מחיר',
      price_level_number: 'רמת מחיר {0}',
      min_price_error: 'מחיר כרטיס חייב להיות מעל  ',
      price_level_name_helper: 'לדוגמה: סטודנטים, או אזרחים וותיקים',
      price_level_name_label: 'שם רמת מחיר',
      cant_remove_after_sales: 'לא ניתן להסיר רמת תמחור לאחר שנמכרו ממנה כרטיסים',
      remove: 'הסר',
      add_price_level: 'הוסף רמת מחיר',
      add_more_price_levels: 'הגדר רמות מחיר נוספות',
      update_prices: 'עדכון מחירים',
      ticket_prices: 'מחירי כרטיסים'
    },
    edit_mode: 'מצב עריכה',
    edit_categories_button: {
      title: 'עריכת קטגוריות הושבה באירוע זה',
      tooltip: 'הוספה ועריכה של  קטגוריות חדשות לתרשים כדי לתמחר מושבים בצורה שונה, לדוגמה שורה ראשונה או כסאות VIP'
    },
    additional_settings: 'הגדרות נוספות',
    mobile_confirm_button: 'כפתור אישור בחירה במובייל',
    prevent_orphan_seats: 'מניעת כסאות יתומים',
    chart_studio: {
      title: 'עיצוב מפת מושבים',
      validation_error: 'ישנן בעיות במפת המושבים, אנא וודאו את בחירתכם',
      chart_updated: 'מפה עודכנה בהצלחה',
      chart_created: 'מפה נוצרה בהצלחה',
      save: 'שמירה',
      create_new: 'יצירת מפה חדשה'
    }
  },
  seats_chart_admin: `ניהול מפות מושבים`,
  coupons: {
    title: 'קופונים',
    page_title: "קופונים",
    create_new: 'יצירת קופון חדש',
    no_coupons: 'אין קופונים',
    update: 'עדכון קופון',
    create: 'יצירת קופון',
    update_button: 'עדכן קופון',
    create_button: 'צור קופון',
    code: 'קוד',
    name: 'שם',
    apply_to_all_active_events_link: 'החל קופון על כל האירועים הפעילים',
    long_explainer: "ויחול על אירועים עתידיים",
    discount: 'הנחה',
    discount_per_ticket: 'ההנחה היא פר כרטיס',
    discount_type: 'סוג הנחה',
    percentage: 'אחוזים',
    fixed_price: 'מחיר קבוע',
    quantity: 'כמות',
    quantity_helper: 'לכמות בלתי מוגבלת, הכניסו 0 או השאירו שדה זה ריק',
    active: 'פעיל',
    not_active: 'לא פעיל',
    unlimited: 'ללא הגבלה',
    used: 'מומשו',
    edit: 'עריכה',
    delete: 'מחיקה',
    duplicate: 'שכפול',
    apply_to_all_active_events_modal_description: 'האם להחיל את הקופון על כל האירועים הפעילים?',
    apply_to_all_active_events_modal_title: 'הקופון יחול על כל האירועים העתידיים',
    applied_to_all_active_events_successfully: 'הקופון הוחל בהצלחה על {{count}} אירועים',
  },
  tickets: `כרטיסים`,
  season_tickets_discount: {
    title: 'הנחות מנוי',
    create_new: 'יצירת הנחה חדשה',
    create: 'יצירת הנחה',
    edit: 'עריכת הנחה',
    discount: 'הנחה',
    discount_per_ticket: 'ההנחה היא פר כרטיס',
    discount_type: 'סוג הנחה',
    percentage: 'אחוזים',
    subscription_type: 'סוג מנוי',
    update: 'עדכון הנחה',
    fixed_price: 'מחיר קבוע',
    for: 'עבור',
    entry_pass: 'כרטיסייה',
    subscription: 'מנוי'
  },
  event_orders: `הזמנות`,
  event_links: `לינקים`,
  my_events: `האירועים שלי`,
  user: `user`,
  list: `list`,
  shop: `shop`,
  blog: `blog`,
  post: `post`,
  mail: `mail`,
  chat: `chat`,
  cards: `cards`,
  posts: `posts`,
  create: `create`,
  kanban: `kanban`,
  banking: `banking`,
  booking: `booking`,
  profile: `profile`,
  account: `account`,
  product: `product`,
  invoice: `invoice`,
  details: `details`,
  checkout: `checkout`,
  analytics: `analytics`,
  ecommerce: `e-commerce`,
  menu_level: `menu level`,
  menu_level_2a: `menu level 2a`,
  menu_level_2b: `menu level 2b`,
  menu_level_3a: `menu level 3a`,
  menu_level_3b: `menu level 3b`,
  menu_level_4a: `menu level 4a`,
  menu_level_4b: `menu level 4b`,
  item_disabled: `item disabled`,
  item_label: `item label`,
  item_caption: `item caption`,
  item_external_link: `item external link`,
  description: `description`,
  other_cases: `other cases`,
  item_by_roles: `item by roles`,
  only_admin_can_see_this_item: `Only admin can see this item`,
  DAILY: `יומי`,
  WEEKLY: `שבועי`,
  MONTHLY: `חודשי`,
  YEARLY: `שנתי`,
  UNKNOWN: `לא ידוע`,
  EMAIL_MARKETING_CONSENT: {
    BASIC: `אישור קבלת תוכן שיווקי בדוא"ל`,
    SHORTER: "אני רוצה עדכונים למייל",
    LONGER: `אישור קבלת עדכונים, והצעות שיווקיות לאימייל `,
    COOLER: "עדכנו אותי על אירועים ומבצעים שווים!"
  },
  top_up: {
    title: `טעינת קרדיטים`,
    subtitle: `מה הסכום לטעינה?`,
    success: `הטעינה בוצעה בהצלחה!`,
    amount: `סכום הטעינה`,
    new_order: `לטעינה נוספת`,
    pay: `לתשלום`,
  },
  calendar_view: {
    event_title: 'כותרת האירוע',
    event_description: 'תיאור ',
    update_success: 'האירוע עודכן בהצלחה',
    create_success: 'האירוע נוצר בהצלחה',
    delete_success: 'האירוע נמחק בהצלחה',
    choose_club_member: 'בחר חבר מועדון',
    register: 'הרשמה',
    event_type: {
      table_reservation: 'הזמנת שולחן',
      tour: 'סיור',
      task: 'משימה',
      regular: 'רגיל',
      wellness: 'בריאות',
      label: 'תווית'
    },
    set_event_type: "קבע סוג אירוע",
    edit_event: "ערוך אירוע",
    add_event: "הוסף אירוע",
    delete_event: "מחק אירוע",
    create_event: "צור אירוע",
    update_event: "עדכן אירוע",
    // New translations for EventType component
    tableReservation: {
      guestCount: "מספר אורחים",
      specialRequests: "בקשות מיוחדות",
      member: "חבר מועדון",
    },
    tour: {
      prospect: {
        firstName: "שם פרטי",
        lastName: "שם משפחה",
        phone: "טלפון"
      },
      tourGuide: "מדריך סיור",
      notes: "הערות"
    },
    task: {
      assignedTo: "מיועד ל",
      taskStatus: "סטטוס משימה",
      status: {
        pending: "ממתין",
        in_progress: "בתהליך",
        completed: "הושלם"
      }
    },
  },
  seller_public: {
    no_subscriptions: 'אין מנויים זמינים כעת',
    no_entry_passes: 'אין כרטיסיות זמינות כעת',
    no_events: 'אין אירועים',
    thank_you_for_purchase: 'תודה רבה על הרכישה',
    how_to_use_subscription: 'איך משתמשים במנוי?',
    subscription_usage_instructions: 'פשוט נכנסים לעמוד האירועים בוחרים אירוע מזמינים כרטיסים והמחיר מתעדכן אוטומטית בהתאם למנוי שרכשתם',
    book_tickets_with_subscription: 'להזמנת כרטיסים בעזרת המנוי',
    continue: 'המשך',
    invalid_phone: 'מספר טלפון לא תקין',
    verification_sent: 'ממש עכשיו שלחנו לך קוד אימות לטלפון',
    enter_verification_code: 'נא להזין את הקוד שקיבלת',
    verification: 'אימות',
    didnt_receive_code: 'לא קיבלת קוד?',
    check_details_and_try_again: 'בדקו את הפרטים ונסו שוב',
    verification_not_found: 'קוד אימות לא נמצא, נא לבקש קוד חדש',
    invalid_verification_code: 'קוד אימות לא תקין',
    personal_details: 'פרטים אישיים',
    payment: 'תשלום',
    login: 'כניסה',
    tickets: 'כרטיסים',
    time_slots: 'חלוקת זמנים',
    upcoming_events: 'אירועים קרובים',
    get_one_time_code: 'לקבלת קוד כניסה חד פעמי',
    enter_phone_number: 'הזינו את מספר הטלפון',
    send_login_code: 'שלח קוד כניסה',
    signup: 'להרשמה',
    fill_details: 'יש למלא את הפרטים הבאים',
    code_sent_again: 'הקוד נשלח שוב',
    try_again: 'נסו שוב',
    phone_not_found: 'מספר הטלפון לא נמצא, בדקו את המספר ונסו שוב',
    error_occurred: 'אירעה שגיאה, נסו שוב מאוחר יותר',
    wrong_verification_code: 'קוד אימות שגוי, בדקו את הקוד נסו שוב',
    phone_already_exists: 'מספר הטלפון כבר קיים במערכת',
    you_are_connected: 'אתם מחוברים',
    signup_here: 'הירשמו כאן',
    ui_customization: {
      font: {
        label: 'גופן מותאם אישית',
        helper: 'הזן את שם משפחת הגופן (למשל, "Roboto", "Open Sans")',
        placeholder: 'הזן כתובת URL של גופן או העלה קובץ גופן'
      },
      fontUrl: {
        label: 'קובץ גופן',
        helper: "אנו ממליצים להשתמש בפורמטים .woff או .woff2",
        placeholder: 'הזן כתובת URL של גופן או העלה קובץ גופן'
      },
      titleFont: {
        label: 'גופן כותרת',
        helper: 'הזן את שם משפחת הגופן לכותרות (למשל, "Roboto Slab", "Montserrat")',
        placeholder: 'הזן שם גופן כותרת'
      },
      titleFontUrl: {
        label: 'קובץ גופן כותרת',
        helper: 'מומלץ להשתמש בפורמט .woff או .woff2 עבור גופן כותרת',
        placeholder: 'הזן כתובת URL של גופן כותרת או העלה קובץ'
      },
      colors: {
        primary: 'צבע ראשי',
        background_overlay: ' פילטר צבע על תמונת רקע'
      },
      loader: {
        label: 'סוג טעינה',
        types: {
          default: 'ברירת מחדל',
          linear: 'קווי',
          circular: 'מעגלי'
        }
      }
    }
  },
  demo: {
    title: 'דמו',
    introduction: 'טקסט דמו להמחשת המערכת',
  },
  documents: {
    id_card: 'תעודת הזהות',
    bank_account: 'שיק מבוטל או אישור ניהול חשבון בנק',
    business_certificate: 'תעודת התאגדות של עוסק פטור/עוסק מורשה/חברה בע"מ/עמותה',
    update: 'עדכון'
  },
  export_data_dialog: {
    header: {
      index: '#',
      order_number: 'מספר הזמנה',
      order_status: 'סטאטוס הזמנה',
      order_date: 'תאריך הזמנה',
      full_name: 'שם מלא',
      gender: 'מין',
      birth_date: 'תאריך לידה',
      phone: 'מספר טלפון',
      phone_excel: 'מספר טלפון (Excel)',
      email: 'אימייל',
      ticket_name: 'שם כרטיס',
      original_price: 'מחיר מקורי',
      price_after_discount: 'מחיר אחרי הנחה',
      refund: 'זיכוי',
      coupon_name: 'שם קופון',
      subscription: 'מנוי',
      late_order: 'הזמנה מאוחרת',
      scanned: 'נסרק'
    },
    order_status: {
      pending: 'ממתין לאישור',
      rejected: 'נדחה',
      paid: 'שולם',
      full_refund: 'זיכוי מלא',
      partial_refund: 'זיכוי חלקי',
      unknown: '-'
    },
    download_data: 'הורד נתונים',
    download: 'הורדה',
    all_orders: 'כל ההזמנות',
    approved_orders: 'הזמנות שאושרו',
    rejected_orders: 'הזמנות שנדחו',
    pending_orders: 'הזמנות ממתינות לאישור',
    refunded_orders: 'הזמנות שזוכו',
    file_name: 'הזמנות אירוע.csv'
  },
  whitelist_dialog: {
    approved_entry: 'מאושרי כניסה',
    set_approved_entry: 'הגדרת מאושרי כניסה',
    segments_description: 'הלקוחות ששייכים לסגמנטים שנבחרו יוגדרו כמאושרי כניסה לאירוע',
    select_segments: 'בחר סגמנטים',
    approved_entry_will_get: 'מאושרי כניסה יקבלו',
    table_mark_only: 'סימון בטבלה בלבד',
    auto_approval: 'אישור כניסה אוטומטי',
    save: 'שמור',
    saved_successfully: 'נשמר בהצלחה',
    save_failed: 'השמירה נכשלה',
    loading: "טוען…"
  },
  docs: {
    hi: 'הי',
    description: 'צריך עזרה? \n אנא בדוק את התיעוד שלנו.',
    documentation: 'תיעוד',
  },
  management: 'ניהול',
  navigation: {
    main: 'ראשי',
    calendar: 'יומן',
    my_links: 'הלינקים שלי',
    system_management: 'ניהול מערכת',
    my_customers: 'הלקוחות שלי',
    my_subscribers: 'המנויים שלי',
    my_sellers: 'המוכרים שלי',
    sellers: 'מוכרים',
    visits_timeline: 'ציר זמן ביקורים',
    customer_club: 'מועדון לקוחות',
    seats_chart_management: 'ניהול מפות מושבים',
    sales_data: 'נתוני מכירות',
    sms_sending: 'שליחת אסמסים',
    legal_settings: 'הגדרת תקנון',
    payment_settings: 'הגדרות תשלום',
    financial_management: 'ניהול כספים',
    productions_management: 'ניהול הפקות',
    choose_production: 'בחירת הפקה',
    production_users: 'משתמשי הפקה',
    production_settings: 'הגדרות הפקה',
    event_management: 'ניהול אירועים',
    event_settings: 'הגדרות אירוע',
    coupons: 'קופונים',
    free_tickets: 'כרטיסים חינם',
    season_tickets_discount: 'הנחות מנוי',
    seats_chart: 'מפת מושבים',
    time_slots: 'חלוקת זמנים',
  },
  free_tickets: {
    title: 'כרטיסים חינם',
    description: 'הוסף הזמנות חינם למשתתפי האירוע שלך. ניתן להוסיף אותם ידנית אחד אחד, או לייבא רשימה מקובץ אקסל.',
    manual_entry: 'הוספה ידנית',
    manual_entry_description: 'שלח כרטיס חינם על ידי הזנת פרטי המשתתף',
    excel_import: 'ייבוא מאקסל',
    excel_import_description: 'ייבוא הזמנות חינם מרובות מקובץ אקסל',
    add_manual: 'שלח כרטיס חינם',
    import_excel: 'ייבוא מאקסל',
    first_name: 'שם פרטי',
    last_name: 'שם משפחה',
    phone: 'טלפון',
    email: 'אימייל',
    phone_required: 'מספר טלפון הוא שדה חובה',
    email_optional: 'אימייל הוא שדה אופציונלי',
    create_ticket: 'שלח כרטיס חינם',
    create_tickets: 'שלח {{count}} כרטיסים חינם',
    success_single: 'הזמנה חינם נוצרה בהצלחה',
    success_bulk: '{{count}} הזמנות חינם נוצרו בהצלחה',
    all_failed: 'לא ניתן ליצור הזמנות חינם. אנא נסה שוב.',
    partial_success: '{{success}} הזמנות נוצרו בהצלחה, {{failed}} נכשלו',
    error: 'שגיאה ביצירת כרטיס חינם',
    validation_error: 'יש למלא את כל השדות הנדרשים',
    no_tickets_error: 'לא הוגדרו כרטיסים לאירוע זה',
    excel_format_info: 'פורמט קובץ אקסל',
    excel_format_required: 'עמודות נדרשות',
    excel_format_optional: 'עמודות אופציונליות',
    supported_formats: 'פורמטים נתמכים',
    excel_no_worksheet: 'לא נמצא גיליון בקובץ האקסל',
    excel_missing_columns: 'חסרות עמודות נדרשות',
    excel_missing_columns_desc: 'קובץ האקסל חייב להכיל עמודות עבור שם פרטי, שם משפחה וטלפון',
    excel_no_valid_rows: 'לא נמצאו שורות תקינות',
    excel_no_valid_rows_desc: 'קובץ האקסל אינו מכיל שורות תקינות עם הנתונים הנדרשים',
    excel_parse_error: 'שגיאה בניתוח הקובץ',
    excel_read_error: 'שגיאה בקריאת הקובץ',
    excel_read_error_desc: 'לא ניתן לקרוא את הקובץ שהועלה',
    excel_error: 'שגיאה',
    excel_parsed_success: 'נותחו בהצלחה {{count}} רשומות',
    excel_invalid_rows: '{{count}} שורות דולגו עקב שדות חובה חסרים',
    excel_missing_required: 'חסרים שדות חובה (שם פרטי, שם משפחה או טלפון)',
    excel_preview: 'תצוגה מקדימה',
    creating_progress: 'יוצר {{current}} מתוך {{total}}...',
    step_upload: 'העלאה',
    step_review: 'סקירה ויצירה',
    back: 'חזרה',
    create_special_ticket_title: 'יצירת סוג כרטיס חינם',
    create_special_ticket_description: 'לפני חלוקת כרטיסים חינם, עליך ליצור סוג כרטיס חינם מיוחד לאירוע זה. כרטיס זה ישמש לכל חלוקות הכרטיסים החינם.',
    ticket_name: 'שם כרטיס חינם',
    default_ticket_name: 'כרטיס חינם',
    create_button: 'צור כרטיס',
    special_ticket_created: 'סוג כרטיס חינם נוצר בהצלחה',
    ticket_name_already_exists: 'כרטיס בשם זה כבר קיים',
    ticket_settings: 'הגדרות כרטיס חינם',
    edit_ticket: 'עריכת כרטיס',
    ticket_updated: 'הכרטיס עודכן בהצלחה',
    save_changes: 'שמור שינויים',
    importing_title: 'מייבא כרטיסים חינם',
    import_in_progress: 'הייבוא מתבצע. ניתן לסגור חלון זה ולהמשיך לעבוד.',
    import_failed_count: '{{count}} נכשלו',
    import_continue_background: 'ניתן לסגור חלון זה. הייבוא ימשיך ברקע.',
  },
  event_type: 'סוג אירוע',
  legal: {
    text: 'טקסט',
    default_policy: 'המערכת תציג את מדיניות ברירת המחדל',
    hide_policy: 'המערכת תסתיר את הקישור למדיניות הפרטיות',
    hide_privacy_policy: 'המערכת תסתיר את הקישור למדיניות הפרטיות'
  },
  event_form: {
    short_url: 'כתובת מקוצרת',
    image_size_ideal: 'גודל אידאלי - רוחב {{width}} וגובה {{height}}',
    event_with_seats: 'אירוע עם מקומות מסומנים',
    ticket_price_min: 'מחיר כרטיס חייב להיות מעל  ',
    count_tickets_min: 'חייב להיות מעל 0',
    seats_prices_note: 'במידה ואופציה זו נבחרה, מחירי הכרטיסים יהיו ניתנים לשינוי בעמוד ״מפת מושבים״',
    wellness_event: 'אירוע בריאות',
    wellness_event_note: 'בחר באפשרות זו אם האירוע כולל מדריך',
    trainer: 'מדריך',
    members_only_event: 'אירוע לחברי מועדון בלבד',
    members_only_event_note: 'במידה ואופציה זו נבחרה, רק חברי מועדון יוכלו לרכוש כרטיסים לאירוע',
    field_locked_after_orders: 'לא ניתן לשנות שדה זה לאחר שבוצעו רכישות',
    buyer_pays_fee: 'עמלת רכישה תשולם על ידי רוכש הכרטיס',
    option_disabled_for_seats_event: 'לא ניתן לבחור באפשרות זאת בארוע עם מקומות מסומנים',
    save: 'שמור',
    no_edit_access: 'אין גישה לעריכת האירוע',
    form_validation_error: 'טופס אינו תקין, אנא בדקו את השדות',
    price_label: 'מחיר',
    min_price_error: 'מלפחות 5 '
  },
  membership_club: {
    payment_system: {
      title: 'מערכת תשלומים',
      description: 'לגביה וניהול של חיובים קבועים'
    },
    messaging_system: {
      title: 'מערכת שליחת הודעות',
      description: 'אימיילים סמס ווטסאפ לתקשורת ישירה עם הלקוחות שלכם'
    },
    event_management: {
      title: 'מערכת ניהול אירועים',
      description: 'כרטיסים מושבים שמורים והזמנה של חברים'
    },
    access_control: {
      title: 'מערכת בקרת כניסות',
      description: 'לדעת מי נמצא במתחם שלכם והאם הוא רשאי להיכנס'
    },
    we_understand: 'אנחנו מבינים את הצורך שלכם',
    similar_to_customers: 'אם אתם דומים ללקוחות שעברו אלינו, אתם  משתמשים בכמה מערכות שונות וצריכים להעביר מידע ממערכת למערכת',
    wasting_time: 'אתם מבזבזים זמן וכסף על מערכות שונות ומתקשים לתפעל את הכל ביחד אנחנו מציעים לכם פתרון אחד להכל',
    competitive_world: 'בעולם התחרותי של היום, ניהול יעיל של מועדון חברים הוא המפתח להצלחת העסק שלך. המערכת של נימי מציעה פתרון כולל שיהפוך את מועדון החברים שלך למנוע צמיחה אמיתי.',
    vision: {
      title: 'לא משנה איך תקראו לזה',
      subtitle: 'מועדון חברים מועדון לקוחות או תוכנית מנויים',
      solution: 'נימי מציעה פתרון כולל',
      growth: 'שמייצר מנוע צמיחה אמיתי ומתמשך לעסק שלכם'
    },
    testimonials: {
      advanced_solution: 'נימי מציעה פתרון מתקדם אחד להכל',
      management_system: 'מערכת הניהול של נימי מתחברת לאתר שלכם ומאפשרת לכם לנהל את כל הפעילויות שלכם במקום אחד מערכת אחת לניהול האירועים מועדון החברים המתחם ניהול הכספים וניהול קמפיינים שיווקיים',
      discover: 'גלו איך נימי יכולה לקחת את מועדון החברים האקסלוסיבי שלכם לשלב הבא',
      contact: 'צור קשר',
      website: {
        title: 'אתר אינטרנט בוורדפרס מותאם אישית',
        subtitle: 'הקמה ותחזוקה מלאה של אתר מקצועי המותאם למותג שלך ולצרכים שלך',
        features: [
          'מערכת ניהול תוכן קלה לעדכון, שינוי והוספת תוכן.',
          'ממשק ידידותי ללקוחות לצפייה במידע ורכישת כרטיסים,',
          'חברי מועדון מתחברים בקלות באמצעות הטלפון ורואים את ההטבות שהם זכאים אליהם.',
          'רוכשים מזדמנים רואים מחיר אחר בהתאם למחיר שקבעתם.',
          'המערכת מאפשרת לרכוש כרטיס בודד כרטיסייה או מנוי עם חיוב מתחדש באופן אוטמטי'
        ]
      },
      management: {
        title: 'מערכת אחת לניהול האירועים מועדון החברים והמתחם',
        subtitle: 'ניהול מתקדם של מועדון החברים (CRM)',
        features: [
          'דשבורד מרכזי לניהול כל פעילויות העסק כולל תצוגות שונות (קלנדר,רשימה וכו)',
          'אפשרות להגדיר דף נחיתה לאירוע שפתוח לקהל הרחב (לא דרך האתר של החברים) עבור אירועים ציבוריים',
          'אפשר להגדיר אירועים חד פעמיים (מסיבות, אירועי השקה וכו) או אירועים סדרתיים (וולנס, יוגה וכו)',
          'תצוגת נתונים בזמן אמת על כמות המבקרים במתחם',
          'מערכת הטבות והנחות דינמית לחברים (ולמזדמנים): בכל אירוע תוכלו להגדיר איזו הטבה חבר מקבל (למשל כניסה חינם או הנחה)',
          'יכולים להגדיר מספר מנויים שונים (לאותו אירוע) ולכל מנוי תנאים שונים'
        ]
      },
      finance: {
        title: 'ניהול כספים',
        subtitle: 'ניהול כספים וחיובים מתקדם',
        features: [
          'הוצאת חשבוניות אוטומטית או ידנית',
          'שליחת תשלומים לספקים מהכסף של האירועים',
          'שליחת בקשת תשלום',
          'תצוגה של כל הטרנזקציות ומיון לפי אירועים, מנויים וכו',
          'מנויים מתחדשים בצורה אוטמטית ואין צורך לחייב ידנית בכל חודש'
        ]
      },
      marketing: {
        title: 'ניהול שיווק ומכירות',
        subtitle: 'מערכת לניהול קמפיינים שיווקיים',
        features: [
          'מערכת משוכללת לשליחת הודעות SMS ללקוחות',
          'ניהול מערך התשלומים והכספים בצורה פשוטה',
          'מעקב אחר נתוני מכירות והכנסות',
          'הפקת דוחות מפורטים על ביצועי מכירות',
          'ניתוח מגמות ותובנות עסקיות'
        ]
      },
      hero: {
      }
    }
  },
  success_stories: {
    title_prefix: 'סיפורי הצלחה של',
    our_clients: 'הלקוחות שלנו',
    to_website: 'לאתר',
    clients: {
      zoa: {
        name: 'זואה',
        role: 'מועדון כושר'
      },
      radical: {
        name: 'רדיקל',
        role: 'מועדון כושר'
      },
      camel: {
        name: 'קאמל',
        role: 'מועדון כושר'
      }
    }
  },
  scanner: {
    start_scanning: 'התחל לסרוק',
    allow_camera_access: 'Please allow camera access',
    scan_success: 'נסרק בהצלחה',
    continue_scanning: 'המשך לסרוק',
    attention: 'שימו לב',
    try_again: 'נסו שוב',
    error: 'Error',
    server_error: 'יש תקלה נסו לרענן את הדף ונסו שוב',
    select_camera: 'Select Camera'
  },
  sub_accounts: {
    my_productions: 'ההפקות שלי',
    create_production: 'יצירת הפקה',
    no_productions: 'אין הפקות',
    handler_exists: 'כתובת מקוצרת זו כבר קיימת במערכת',
    handler_description: '״הכתובת המקוצרת״ היא הקידומת של ההפקה בלינק של כל אירוע. לדוגמא: אם כתובת מקוצרת היא "groove-productions" כך יראה תחילת הלינק לכל אירוע תחת אותה הפקה - ',
    name: 'שם',
    short_url: 'כתובת_מקוצרת',
    submit: 'אישור',
    edit: 'עריכה',
    edit_production: 'עריכת הפקה',
    attention: 'שים לב',
    links_will_change: 'הלינקים לארועים של ההפקה עומדים להשתנות והלינקים הקיימים יפסיקו לעבוד',
    my_sellers_productions: 'הפקות המוכרים שלי',
    search_production: 'חיפוש הפקה...'
  },
  settings: {
    max_capacity: {
      title: 'רוצה למכור כרטיסים לאירוע עם מספר סוגי כרטיסים, אבל יש לך מספר מוגבל של מקומות?',
      example: 'לדוגמה, נניח שיש לך 100 כרטיסים רגילים ו-100 כרטיסים עם שי, אבל רק 100 מקומות באולם.',
      explanation: 'במקרה כזה, חשוב שתוכל לאפשר ללקוחות לבחור את סוג הכרטיס הרצוי, ובמקביל לוודא שלא יימכרו יותר מ-100 כרטיסים בסך הכל.'
    },
    event_link: 'קישור לעמוד אירוע:',
    show_in_seller_page: 'אירוע יוצג <customLink>בדף המוכר הראשי</customLink>',
    show_in_seller_page_plain: 'אירוע יוצג בדף המוכר הראשי',
    waiting_list: 'אירוע עם רשימת המתנה',
    allow_coupons: 'אפשר קופונים עבור אירוע זה',
    seats_event_tooltip: 'לא ניתן לבחור באפשרות זאת בארוע עם מקומות מסומנים',
    min_capacity_error: 'חייב להיות מעל 1',
    max_capacity_error: 'חייב להיות מתחת ל',
    one_user_form: 'הגבל לטופס משתמש אחד גם בהזמנה מרובת כרטיסים',
    allow_season_ticket: 'אפשר כרטיס מנוי',
    show_seller_header: 'הצג סרגל סרגל עליון ',
    is_bookable: 'האירוע ניתן להזמנה למנוים בלבד ',
    is_bookable_helper: 'מנויים מחוברים יכולים לשמור לעצמם מקום באירוע ללא צורך לעבור דרך דף רכישת הכרטיסים ',
    is_bookable_with_tickets: 'האירוע ניתן להזמנה למנוים ומאפשר גם רכישת כרטיסים רגילה ללא מנויים',
    is_bookable_with_tickets_helper: 'מנויים מחוברים יכולים לשמור לעצמם מקום באירוע בלחיצה אחת או לעבור לדף האירוע, משתמש שאינו מנוי יועבר ישר לדף האירוע',
    what_is_seller_page: 'מה זה דף המוכר?',
    seller_page_explanation: 'דף המוכר נועד לעזור לך למכור יותר, על ידי הצגת כל ההפקות והאירועים שלך במקום אחד, אתה יכול גם למכור כרטיסיות ומנויים חודשים ועוד הרבה יותר. אתה יכול להשתמש בו כדי לבנות קהילה של לקוחות נאמנים.',
    seller_page_settings: 'הגדרות דף המוכר',
    allow_split_payment: 'אפשר תשלום מפוצל',
    allow_members_one_ticket_only: 'הגבל חברי מועדון להזמנה אחת באירוע',
    max_capacity_switch: 'הגבל כמות כרטיסים כוללת',
    max_tickets: 'מספר מקסימלי של כרטיסים למכירה',
    no_edit_access: 'אין גישה לעריכת האירוע',
    only_for_members: 'האירוע מוגבל לחברי מועדון בלבד',
    seller_page_behavior: 'התנהגות האירוע בעמוד המוכר'
  },
  form_fields: {
    translation_support_note: 'הערה רק כותרות השדה הבאות יתורגמו לשפות נוספות',
    supported_fields: '  כותרות השדה',
    birthday: {
      label: 'תאריך לידה',
      title: 'תאריך לידה'
    },
    first_name: {
      label: 'שם פרטי',
      title: 'שם פרטי'
    },
    last_name: {
      label: 'שם משפחה',
      title: 'שם משפחה'
    },
    email: {
      label: 'אימייל',
      title: 'אימייל'
    },
    phone: {
      label: 'טלפון',
      title: 'טלפון'
    },
    gender: {
      label: 'מין',
      title: 'מין'
    },
    social_link: {
      label: 'קישור לרשת חברתית',
      title: 'קישור לרשת חברתית',
      allowed_networks: 'רשתות חברתיות מותרות',
      select_networks: 'בחר רשתות חברתיות',
      validation_error_label: 'הודעת שגיאה מותאמת אישית',
      validation_error_default: 'אנא ספק קישור לרשת חברתית תקין',
      link_required: 'קישור נדרש',
      links_required: 'קישורים נדרשים',
      or: 'או'
    },
    email_marketing: {
      label: 'הסכמה לאימייל שיווקי ',
      title: 'הסכמה לאימייל שיווקי'
    },
    example: {
      title: 'פרטי הזמנה - דוגמא',
      label: 'פרטי הזמנה - דוגמא'
    },
    required: 'שדה חובה',
    hide: 'הסתר שדה',
    field_title: 'כותרת שדה',
    cant_hide_required: 'לא ניתן להסתיר שדה חובה',
    business_code: {
      label: 'מספר חברה (ח.פ.)',
      title: 'מספר חברה (ח.פ.)'
    },
    business_name: {
      label: 'שם חברה',
      title: 'שם חברה'
    },
  },
  search_advanced: 'חיפוש מתקדם',
  search_users_in_segments: 'חפש משתמשים השייכים לסגמנטים אלו',
  table: {
    type: 'סוג',
    name: 'שם',
    status: 'סטטוס',
    action: 'פעולה',
    additional_data: 'מידע נוסף',
  },
  marketplace: {
    email_already_exists: 'כתובת אימייל כבר קיימת',
    handler_already_exists: 'כתובת מקוצרת כבר קיימת במערכת',
    market_fee_minimum: 'סכום העמלה חייב להיות מעל - {{0}}%',
    form: {
      password: 'סיסמא',
      seller_name: 'שם מוכר',
      phone: 'טלפון',
      gov_id: 'מספר זהות',
      market_fee: 'עמלת סליקה',
      market_fee_helper: '(עמלת סליקה כולל מע״מ)',
      market_fee_min_amount: 'סכום מינימלי - {{0}}%',
      add: 'הוספה'
    },
    sellers: {
      no_approved_sellers: 'אין מוכרים מאושרים',
      pending_approval: 'ממתינים לאישור',
      my_sellers: 'המוכרים שלי - {{0}}',
      add_new_seller: 'הוספת מוכר חדש',
      no_sellers: 'אין מוכרים',
      status: {
        active: 'פעיל',
        created: 'נוצר',
        unknown: '---'
      },
      details: {
        email: 'אימייל - ',
        phone: 'טלפון',
        registration_date: 'תאריך הרשמה',
        market_fee: 'עמלת סליקה - ',
        terminal_setup: 'הסדר מסוף סליקה',
        use_existing_terminal: 'אני רוצה להשתמש במסוף שלי עבור חשבון זה - הכסף יעבור לחשבון הבנק שלי',
        create_new_terminal: 'אני רוצה לפתוח חשבון מסוף חדש והכסף יעבור לחשבון הבנק החדש'
      },
      approve_seller: 'אשר מוכר',
      approved_successfully: 'המוכר אושר בהצלחה',
      edit: 'ערוך',
      edit_seller: 'ערוך מוכר',
      name: 'שם',
      name_placeholder: 'הזן שם מוכר',
      email: 'אימייל',
      email_placeholder: 'הזן אימייל מוכר',
      market_fee: 'עמלת שוק (%)',
      market_fee_placeholder: 'הזן אחוז עמלת שוק',
      market_fee_min: 'עמלת שוק חייבת להיות לפחות 0%',
      market_fee_max: 'עמלת שוק לא יכולה לעלות על 100%',
      save_changes: 'שמור שינויים',
      search_placeholder: 'חפש מוכרים לפי שם...',
      no_search_results: 'לא נמצאו מוכרים',
      no_search_results_description: 'לא נמצאו מוכרים התואמים ל"{{query}}"'
    }
  },
  private_club: {
    select_visitor: 'מבקרים',
    visitor_count: 'מספר המבקרים',
    member_returned: 'חבר המועדון חזר?',
    member_left: 'חבר המועדון יצא?',
    update_visitor_count: 'עדכן מספר מבקרים',
    all_left: 'כולם יצאו',
    enter: 'כניסה',
    active: 'פעיל',
    exited: 'יצא',
    visits_report: 'דו״ח ביקורים'
  },
  visits_timeline: {
    title: 'דוח ציר זמן ביקורים',
    total_visits: 'סך כל הביקורים',
    total_guests: 'סך כל האורחים',
    avg_guests: 'ממוצע אורחים/ביקור',
    avg_duration: 'משך זמן ממוצע',
    filters: 'מסננים',
    start_date: 'תאריך התחלה',
    end_date: 'תאריך סיום',
    select_member: 'בחר חבר',
    all_members: 'כל החברים',
    apply: 'החל',
    clear: 'נקה',
    today: 'היום',
    yesterday: 'אתמול',
    last_7_days: '7 ימים אחרונים',
    last_30_days: '30 ימים אחרונים',
    last_90_days: '90 ימים אחרונים',
    visit_history: 'היסטוריית ביקורים',
    no_visits_found: 'לא נמצאו ביקורים עבור המסננים שנבחרו',
    date: 'תאריך',
    member: 'חבר',
    guests: 'אורחים',
    entry_time: 'שעת כניסה',
    exit_time: 'שעת יציאה',
    duration: 'משך זמן',
    status: 'סטטוס',
    visits: 'ביקורים',
    daily_visits: 'מגמת ביקורים יומית',
    daily_visits_subtitle: 'מספר ביקורים ואורחים ליום',
    hourly_visits: 'ניתוח שעות שיא',
    hourly_visits_subtitle: 'התפלגות ביקורים לאורך היום'
  },
  user_event_form: {
    order_status: 'סטאטוס הזמנה',
    approved: 'מאושר'
  },
  refund_dialog: {
    money_already_transferred: 'מצטערים, לא ניתן לבצע זיכוי עבור הזמנות באירוע זה מאחר והכסף כבר הועבר לחשבונכם',
    refund_amount: 'סכום הזיכוי',
    refund_amount_error: 'סכום הזיכוי גדול מהסכום המקסימלי',
    refund_amount_label: 'בחירת סכום הזיכוי',
    refund_amount_helper: 'סכום הזיכוי אינו יכול לעלות על סכום ההזמנה',
    refund_tickets: 'זיכוי כרטיסים',
    refund_all_tickets: 'זיכוי כל הכרטיסים',
    ticket_name: 'שם כרטיס',
    ticket_price: 'מחיר',
    refund_fee: 'עמלת זיכוי',
    refund_fee_info: 'עמלת זיכוי של {{0}}% תקוזז מסכום הזיכוי',
    buyer_paid_fee: 'סכום עמלה (שולמה על ידי הרוכש) - {{amount}}',
    refund: 'זיכוי',
    cancel: 'ביטול',
    order_amount: 'סכום הזמנה',
    already_refunded_amount: 'הזמנה כבר זוכתה בסכום',
    tickets_return_caption: 'הכרטיסים המסומנים יוחזרו למאגר הכרטיסים למכירה',
    ticket_refunded: 'זוכה',
  },
  time_slots: {
    select_date: 'בחירת תאריך',
    select_date_helper: 'בחרו את התאריך המועדף עליכם',
    available_times: 'שעות זמינות',
    season_period: 'תקופת עונה',
    booking_window: 'חלון הזמנה',
    days_in_advance: 'ימים מראש',
    operating_days: 'ימי פעילות',
    every_day: 'כל יום',
    spots: 'מקומות',
    available: 'זמינים',
    only_x_left: 'נותרו רק {{count}}',
    x_spots_left: 'נותרו {{count}} מקומות',
    x_available: '{{count}} זמינים',
    selected: 'נבחר',
    fully_booked: 'מלא',
    no_slots_available: 'אין שעות זמינות',
    try_different_date: 'אנא נסו תאריך אחר',
    select_time_helper: 'בחרו את השעה המועדפת עליכם כדי להמשיך',
    error_loading_slots: 'שגיאה בטעינת השעות. אנא נסו שוב.',
    back_to_time_selection: 'חזרה לבחירת שעה',
    view_grid: 'כרטיסיות',
    view_list: 'רשימה',
    view_grid_tooltip: 'תצוגת כרטיסיות - הצג שעות כרטיסים גדולים',
    view_list_tooltip: 'תצוגת רשימה - הצג שעות כטבלה',
    toggle_view: 'החלף מצב תצוגה',
    time: 'שעה',
    capacity: 'קיבולת',
    status: 'סטטוס',
    action: 'פעולה',
    select: 'בחר',
    tap_to_select: 'לחצו על השורה לבחירת השעה',
    time_slot: 'חלונית זמן',
  },
  days: {
    monday: 'יום שני',
    tuesday: 'יום שלישי',
    wednesday: 'יום רביעי',
    thursday: 'יום חמישי',
    friday: 'יום שישי',
    saturday: 'יום שבת',
    sunday: 'יום ראשון',
  },
  inner_row: {
    approved: 'מאושר',
    not_approved: 'לא מאושר',
    refunded: 'זוכה',
    scanned: 'נסרק',
    not_scanned: 'לא נסרק',
    free_ticket: 'כרטיס חינם',
    cannot_scan_unapproved: 'לא ניתן לסרוק רוכש שלא אושר',
    seat_label: 'מושב: {{0}}'
  },
  table_columns: {
    subscription: 'מנוי'
  },
  event_order_table: {
    whitelist_tooltip: 'מופיע ברשימת מאושרי הכניסה',
    late_order: 'הזמנה מאוחרת',
    free: 'חינם'
  },
  transformers: {
    yes: 'כן',
    no: 'לא',
    hrc_errors: {
      subscription_already_used: 'מנוי כבר שומש',
      subscription_not_active: 'מנוי נמצא אך לא פעיל או עבר את המכסה',
      no_entries_left_for_event: 'לא נותרו כניסות למימוש באירוע זה',
      no_entries_left: 'לא נותרו כניסות למימוש',
      not_configured_for_event: 'המנוי אינו מוגדר לשימוש באירוע זה',
      subscription_not_found: 'מנוי לא נמצא',
      end_user_season_ticket_not_found: 'מנוי לא נמצא'
    },
    order_number_prefix: 'הזמנה מספר'
  },
  seatsIo: {
    table: 'שולחן',
    row: 'שורה',
    seat: 'כיסא'
  },
  payment: {
    technical_error: 'ישנה טקלה טכנית, נסו לרענן את העמוד וננסה שנית. התקלה אמורה לסתדר',
    total: 'סה"כ',
    card_number: 'מספר כרטיס',
    expiration: 'תוקף',
    cvv: 'CVV',
    first_name: 'שם פרטי',
    last_name: 'שם משפחה',
    social_id: 'תעודת זהות',
    pay_now: 'שלם עכשיו',
    initializing: 'מאתחל תשלום...',
    initialization_error: 'כשל באתחול תשלום',
    initialization_failed: 'אתחול התשלום נכשל',
    no_provider_configured: 'לא הוגדר ספק תשלום',
    waiting_initialization: 'ממתין לאתחול תשלום...',
    stripe_not_enabled: 'תשלומי Stripe אינם מופעלים. אנא צור קשר עם המוכר.',
    stripe_account_not_connected: 'אמצעי תשלום לא זמין. אנא צור קשר עם המוכר.',
    configuration_required: 'נדרשת תצורת תשלום',
    stripe_account_id_missing: 'מזהה חשבון Stripe חסר',
    stripe_charges_not_enabled: 'חיובי Stripe אינם מופעלים',
    stripe_currency_not_configured: 'מטבע Stripe לא מוגדר',
    payme_not_configured: 'PayMe אינו מוגדר. אנא הגדר PayMe או בחר ספק תשלום אחר.',
    payme_public_key_missing: 'מפתח ציבורי של PayMe חסר',
    retry: 'נסה שוב'
  },
  warnings: {
    attention: 'שימו לב',
    no_tickets_defined: 'עדין לא הוגדרו כרטיסים לאירוע זה',
    define_tickets: 'הגדרת כרטיסים'
  },
  date_operator: {
    between: 'בין',
    from_date: 'החל מתאריך',
    to_date: 'עד לתאריך'
  },
  footer: {
    sections: {
      services: 'שירותים',
      links: 'קישורים',
      terms: 'תקנון',
      contact: 'צור קשר'
    },
    links: {
      club_management: 'ניהול מועדון חברים',
      scanner_apple: 'סורק כרטיסים Apple App Store',
      scanner_google: 'סורק כרטיסים Google Play Store',
      privacy_policy: 'מדיניות פרטיות',
      terms_of_service: 'תנאי שימוש',
      talk_to_us: 'דברו איתנו',
      address: 'הכתובת',
      address_text: 'mind-space רמת גן'
    }
  },
  promoter: {
    sales_funnel_bottom_line: 'סה״כ הכנסות',
    my_links: 'הלינקים שלי',
    link_details: 'ביצועי הלינק',
    sales_funnel: 'משפך מכירות',
  },
  book_event: {
    book_now: 'הירשמו עכשיו',
    goto_tickets: 'לבחירת כרטיסים',
    success: 'נרשמת בהצלחה',
    success_message: 'נרשמת בהצלחה לאירוע זה!',
    close: 'סגור',
    you_are_not_logged_in: 'אינך מחובר',
    login_required: 'נדרש התחברות',
    login_required_title: 'עליך להתחבר',
    login_required_message: 'על מנת להירשם לאירוע זה, עליך להתחבר לחשבונך.',
    subscription_required: 'נדרש מנוי',
    you_dont_have_a_subscription: 'אין לך מנוי',
    subscription_required_title: 'עליך לרכוש מנוי',
    subscription_required_message: 'על מנת להירשם לאירוע זה, עליך לרכוש תוכנית מנוי.',
    subscription_manual_only_message: 'מנויים עבור מוכר זה זמינים רק באמצעות יצירת קשר ישיר. אנא פנה למוכר לרכישת מנוי.',
    purchase_subscription: 'רכישת מנוי',
    subscription_already_used_for_event: 'המנוי שלך כבר שומש עבור אירוע זה',
    subscription_not_active_or_limit_reached: 'המנוי שלך אינו פעיל או הגיע למגבלתו',
    subscription_event_limit_reached: 'הגעת למספר המקסימלי של כניסות חינם עבור אירוע זה',
    subscription_overall_limit_reached: 'הגעת למגבלה הכללית של המנוי שלך',
    subscription_not_configured_for_event: 'המנוי שלך אינו מוגדר עבור סוג אירוע זה',
    no_active_subscription: 'לא נמצא מנוי פעיל',
    cannot_book_for_free: 'אירוע זה לא יכול להיות מוזמן בחינם עם המנוי הנוכחי שלך',
    booking_failed: 'ההזמנה נכשלה. אנא נסה שוב מאוחר יותר.',
    time_slot_required: 'אנא בחרו שעה לפני ההזמנה',
  },
  common: {
    cancel: 'ביטול',
    login: 'התחברות',
    error_loading_account: 'שגיאה בטעינת פרטי החשבון. אנא נסה שוב.',
  },
  feature_intro: {
    welcome: 'ברוכים הבאים לתכונה זו!',
    default_description: 'גלו מה התכונה הזו יכולה לעשות עבורכם',
    key_features: 'תכונות עיקריות',
    got_it: 'הבנתי!',
    learn_more: 'למידע נוסף',
    show_intro: 'הצג מדריך תכונה',
    customer_club: {
      title: 'מועדון לקוחות - שני סוגי חברויות עוצמתיות',
      description: 'מועדון הלקוחות עוזר לכם לבנות קשרים חזקים יותר עם הלקוחות שלכם באמצעות תוכניות חברות. צרו הצעות בלעדיות, עקבו אחר מעורבות החברים ותגמלו את הלקוחות הנאמנים ביותר שלכם עם הטבות מיוחדות.',
      main_description: 'מועדון הלקוחות מציע שני סוגי חברויות שונות לצרכים שונים של לקוחות. בחרו בין מנוי חוזר (כמו מנוי חודשי לחוג) או כרטיסיית כניסות חד-פעמית (כמו כרטיסייה ל-10 כניסות). לשניהם ניתן להגדיר הנחות מיוחדות לכל אירוע!',
      subscription_title: '1. מנויים - חברויות חוזרות',
      subscription_description: 'כמו מנוי חודשי לחדר כושר או חוג. הלקוחות משלמים אוטומטית כל יום/שבוע/חודש/שנה. מושלם למשתתפים קבועים שרוצים גישה מתמשכת לאירועים שלכם. החברים יכולים לקבל כניסה חינם או הנחות מיוחדות.',
      entry_pass_title: '2. כרטיסיות כניסה - כרטיסיות ניקוב',
      entry_pass_description: 'רכישה חד-פעמית שנותנת ללקוחות מספר קבוע של כניסות (כמו כרטיסייה ל-10 שיעורי יוגה). כל אירוע "מנקב" את הכרטיסייה שלהם. מעולה ללקוחות שרוצים גמישות ללא התחייבות חודשית.',
      redemption_title: 'איך חברים ממשים את ההטבות שלהם',
      redemption_description: 'לחברים יש שתי דרכים קלות להשתמש במנוי או בכרטיסייה שלהם: 1) התחברות עם מספר הטלפון בדף האירוע, או 2) שימוש בקוד המימוש הייחודי שנשלח למייל שלהם לאחר הרכישה. פשוט ומאובטח!',
      how_members_redeem_title: 'איך החברים שלכם משתמשים בחברות',
      redemption_alert: 'החברים מקבלים מייל אישור אוטומטי עם קוד המימוש הייחודי שלהם לאחר הרכישה',
      method1_title: 'שיטה 1: התחברות עם מספר טלפון',
      method1_description: 'החברים פשוט מזינים את מספר הטלפון שלהם בדף הזמנת האירוע. המערכת מזהה אוטומטית את החברות שלהם ומחילה את ההנחה או הכניסה החינמית.',
      method2_title: 'שיטה 2: קוד מימוש במייל',
      method2_description: 'לאחר הרכישה, החברים מקבלים מייל עם קוד מימוש ייחודי. הם יכולים להזין את הקוד הזה בקופה כדי להחיל את הטבות החברות שלהם.',
      screenshot_caption: 'דוגמה: איך החברים רואים את תהליך המימוש',
      screenshot_placeholder_text: 'צילום המסך יוצג כאן כשיסופק',
      automatic_discount_title: 'הנחה אוטומטית בעמוד התשלום',
      automatic_discount_description: 'כאשר חברי המועדון רוכשים כרטיסים לאירועים, ההנחה תחול באופן אוטומטי בעמוד התשלום',
      no_code_needed: 'אין צורך להזין קוד או לבצע פעולה נוספת - המערכת מזהה את החברות ומחילה את ההנחה מיידית',
      checkout_screenshot_caption: 'דוגמה לעמוד התשלום עם הנחת חבר מועדון',
      checkout_image_placeholder: 'כאן תופיע תמונה של עמוד התשלום עם ההנחה האוטומטית',
      event_pricing_title: 'שליטה גמישה בתמחור אירועים',
      event_pricing_description: 'בהגדרות של כל אירוע, אתם מחליטים איזו הנחה כל מנוי או כרטיסייה מקבלים. הגדירו חינם (100% הנחה), 40% הנחה, או כל הנחה שתבחרו. אירועים שונים יכולים להציע הטבות שונות!',
      business_benefits_title: 'למה להשתמש במועדון לקוחות?',
      business_benefits_description: 'הכנסה חוזרת וצפויה ממנויים, נאמנות לקוחות מוגברת, מכירות מראש דרך כרטיסיות כניסה, וגביה אוטומטית. הלקוחות שלכם חוסכים כסף בזמן שאתם בונים עסק יציב!',
      feature1_title: 'ניהול חברים',
      feature1_description: 'נהלו בקלות את חברי המועדון שלכם, עקבו אחר הפעילות שלהם והבינו את ההעדפות שלהם',
      feature2_title: 'הנחות בלעדיות',
      feature2_description: 'צרו קודי הנחה והצעות מיוחדות בלעדית לחברי המועדון שלכם',
      feature3_title: 'אנליטיקה ותובנות',
      feature3_description: 'קבלו אנליטיקה מפורטת על התנהגות החברים, דפוסי רכישה ורמות מעורבות',
      feature4_title: 'גישה לאירועים',
      feature4_description: 'העניקו גישה מיוחדת לאירועים, כרטיסי ציפור מוקדמת או חוויות VIP לחברי המועדון',
    },
    subscription_form: {
      title: 'הבנת מנויים',
      description: 'מנויים הם תוכניות חברות חוזרות המספקות הטבות מתמשכות ללקוחות שלכם. מושלם למשתתפים קבועים שרוצים גישה בלתי מוגבלת או מוזלת לאירועים שלכם.',
      feature1_title: 'תשלומים חוזרים',
      feature1_description: 'הגדירו מחזורי תשלום יומיים, שבועיים, חודשיים או שנתיים. הלקוחות יחויבו אוטומטית בהתאם לתדירות שבחרתם.',
      feature2_title: 'שליטה במגבלת אירועים',
      feature2_description: 'הגדירו לכמה אירועים מנוי יכול להגיע. הגדירו 0 לגישה בלתי מוגבלת, או ציינו מספר מקסימלי של אירועים.',
      feature3_title: 'נראות ציבורית',
      feature3_description: 'בחרו האם להציג את המנוי הזה בדף המוכר הציבורי שלכם לרכישה ישירה על ידי לקוחות.',
    },
    entry_pass_form: {
      title: 'הבנת כרטיסיות כניסה',
      description: 'כרטיסיות כניסה הן חבילות כרטיסים ששולמו מראש שנותנות ללקוחות מספר קבוע של כניסות לשימוש באירועים שלכם. מושלם לגמישות ללא התחייבות.',
      feature1_title: 'מערכת כרטיסייה',
      feature1_description: 'הגדירו מספר כולל של כניסות (ניקובים) שלקוחות יכולים להשתמש. כל השתתפות באירוע משתמשת בניקוב אחד או יותר.',
      feature2_title: 'מגבלות כניסה לאירוע',
      feature2_description: 'שלטו בכמה כניסות ניתן להשתמש לכל אירוע. השאירו ריק לכניסות בלתי מוגבלות לאירוע (עד שהסכום הכולל מגיע).',
      feature3_title: 'רכישה חד פעמית',
      feature3_description: 'כרטיסיות כניסה נרכשות פעם אחת ותקפות עד שכל הכניסות נוצלו, בניגוד למנויים חוזרים.',
    },
    my_members: {
      title: 'החברים שלי - מרכז ניהול החברים המלא',
      description: 'צפו ונהלו את כל הלקוחות שלכם עם מנויים פעילים או כרטיסיות כניסה בלוח בקרה אחד עוצמתי. עקבו אחר מעורבות, הוסיפו הערות, נטרו סטטוס ויצאו נתונים לניתוח מעמיק.',
      search_title: 'חיפוש וסינון חכם',
      search_description: 'מצאו מיידית כל חבר על ידי חיפוש שמות, טלפונים, אימיילים או הערות. השתמשו בפילטרים מתקדמים לסוג מנוי, סטטוס, טווח מחירים וטווחי תאריכים מרובים.',
      status_title: 'מעקב סטטוס בזמן אמת',
      status_description: 'נטרו אילו חברים פעילים או לא פעילים עם תוויות סטטוס צבעוניות. ראו במבט חטוף מי זקוק לתשומת לב או מעורבות מחדש.',
      notes_title: 'מערכת הערות לחברים',
      notes_description: 'הוסיפו הערות מותאמות אישית לכל חבר כדי לעקוב אחר דרישות מיוחדות, העדפות או תקשורת פנימית. שמרו מידע חשוב נגיש תמיד.',
      dates_title: 'אנליטיקת תאריכים מקיפה',
      dates_description: 'עקבו אחר תאריכי הצטרפות, תאריכי ביטול והשתתפות אחרונה כדי להבין דפוסי מעורבות חברים ולזהות מגמות.',
      export_title: 'ייצוא נתונים ודוחות',
      export_description: 'ייצאו את כל נתוני החברים לפורמט CSV לניתוח באקסל או כלים אחרים. תמיכה מלאה ב-UTF-8 מבטיחה תצוגה נכונה של תווים בעברית.',
      profile_title: 'פרופילי חברים מלאים',
      profile_description: 'לחצו על כל חבר כדי לגשת לפרופיל המלא שלו כולל היסטוריית רכישות מלאה, השתתפות באירועים ומידע מנוי מפורט.',
    },
    legal_settings: {
      title: 'הגדרות תקנון - ניהול מדיניות פרטיות ותנאי שימוש',
      description: 'הגדירו את המסמכים המשפטיים של השוק שלכם כולל מדיניות פרטיות, תנאי שימוש ותנאי חברות במועדון. בחרו בין תבניות ברירת מחדל, קישורים מותאמים אישית או העלו מסמכי PDF משלכם כדי להבטיח עמידה בתקנות המקומיות.',
      privacy_title: 'הגדרת מדיניות פרטיות',
      privacy_description: 'הגדירו כיצד מדיניות הפרטיות שלכם מוצגת ללקוחות. השתמשו בתבנית ברירת המחדל שלנו, קשרו למדיניות שלכם, העלו PDF או הסתירו אם לא נדרש.',
      terms_title: 'ניהול תנאי שימוש',
      terms_description: 'הגדירו את תנאי השימוש שלקוחות חייבים לקבל. זה נדרש ולא ניתן להסתיר - בחרו בין ברירת מחדל, קישור מותאם אישית או העלאת PDF.',
      membership_title: 'תנאי חברות במועדון',
      membership_description: 'תנאים ספציפיים לבעלי מנויים וכרטיסיות כניסה. הגדירו בנפרד מהתנאים הכלליים כדי לספק תנאי חברות ברורים.',
      flexibility_title: 'אפשרויות תצוגה גמישות',
      flexibility_description: 'ארבע דרכים להציג כל מסמך: השתמשו בתבניות ברירת מחדל, קשרו לכתובות URL חיצוניות, העלו קובצי PDF או הסתירו (במקום שמותר).',
      compliance_title: 'ציות משפטי בקלות',
      compliance_description: 'הבטיחו שהעסק שלכם עומד בדרישות החוקיות עם תנאים ומדיניות מוגדרים כראוי שמגנים עליכם ועל הלקוחות שלכם.',
      how_it_works_title: 'איך עובדות אפשרויות המסמכים המשפטיים',
      important_note: 'מסמכים משפטיים מופיעים במהלך התשלום וההרשמה. לקוחות חייבים לקבל תנאים לפני השלמת רכישות.',
      options_title: 'אפשרויות זמינות לכל מסמך:',
      option_default: 'השתמשו בתבנית שמסופקת על ידי המערכת (כתובה מקצועית, מכסה דרישות סטנדרטיות)',
      option_link: 'קישור למסמך המשפטי החיצוני שלכם (מאוחסן באתר שלכם)',
      option_pdf: 'העלו מסמך PDF מותאם אישית (מאוחסן בצורה מאובטחת, מוצג ללקוחות)',
      option_hide: 'הסתר מסמך זה (זמין רק למדיניות פרטיות ותנאי חברות)',
      screenshot_caption: 'דוגמה: איך מסמכים משפטיים מופיעים ללקוחות שלכם',
      screenshot_placeholder: 'צילום מסך של הגדרות משפטיות יוצג כאן כשיסופק',
    },
    my_leads: {
      title: 'מערכת ניהול לידים',
      description: 'נהלו את הלידים שלכם מהתעניינות ראשונית דרך אישור ורכישת מנוי. עקבו אחר לידים מהזנה ידנית או webhooks מהאתר, קבעו פגישות והפכו אותם לחברים פעילים.',
      manual_title: 'יצירת ליד ידנית',
      manual_description: 'הוסיפו לידים ידנית עם פרטי הקשר, תחומי העניין והערות שלהם. מושלם ללקוחות שמגיעים פיזית או פניות טלפוניות.',
      webhook_title: 'אינטגרציה עם האתר',
      webhook_description: 'קלטו לידים אוטומטית מהאתר שלכם כאשר מבקרים מביעים עניין להפוך לחברים. לא נדרשת הזנת נתונים!',
      schedule_title: 'תזמון בלוח שנה',
      schedule_description: 'קבעו פגישות ישירות בלוח השנה שלכם לדיון באפשרויות החברות עם חברים פוטנציאליים.',
      approval_title: 'תהליך אישור',
      approval_description: 'סקרו ואשרו לידים להפוך לחברים. הגדירו את הסטטוס שלהם, הוסיפו הערות ועקבו אחר ההתקדמות שלהם.',
      subscription_title: 'רכישת מנוי',
      subscription_description: 'לאחר האישור, חברים יכולים לרכוש מנויים ישירות דרך המערכת, ולהשלים את תהליך ההצטרפות.',
      tracking_title: 'אנליטיקת לידים',
      tracking_description: 'עקבו אחר שיעורי המרה, סטטוס מעקב ומקורות לידים כדי לייעל את תהליך רכישת החברים שלכם.',
    },
    production: {
      title: 'ניהול הפקות - ארגן אירועים כמו מקצוען',
      description: 'הפקות הן תיקיות חכמות שמארגנות אירועים דומים יחד. הן מאפשרות שיתוף פעולה צוותי, הגדרות משותפות, ויצירת כתובות URL מקצועיות ויפות לאירועים שלך.',
      folder_organization_title: 'ארגון חכם של אירועים',
      folder_organization_description: 'קבץ אירועים קשורים (כמו שיעורי יוגה שבועיים, סדנאות חודשיות, או סדרת הופעות) תחת הפקה אחת לניהול יעיל.',
      collaboration_title: 'מרכז שיתוף פעולה צוותי',
      collaboration_description: 'הזמן חברי צוות והקצה תפקידים פעם אחת - הם מקבלים אוטומטית את אותן הרשאות לכל האירועים בהפקה, נוכחיים ועתידיים!',
      url_structure_title: 'כתובות אירוע יפות',
      url_structure_description: 'צור קישורים מקצועיים וקלים לזכירה: your-domain.com/שם-הפקה/שם-אירוע. מושלם לשיווק וגישה קלה ללקוחות.',
      shared_settings_title: 'הגדר פעם אחת, החל על הכל',
      shared_settings_description: 'הגדר אינטגרציות, שאלות לקונים והתנהגות דף פעם אחת להפקה - כל האירועים יורשים את ההגדרות אוטומטית.',
      role_inheritance_title: 'ירושת תפקידים אוטומטית',
      role_inheritance_description: 'כשאתה מוסיף אירוע חדש להפקה, כל המשתפי הפעולה מקבלים מיד גישה על פי התפקידים שלהם. אין צורך בהרשאות ידניות!',
      centralized_management_title: 'לוח בקרה מרכזי',
      centralized_management_description: 'נהל את כל הגדרות ההפקה מלוח אחד: מידע כללי, אינטגרציות, שאלות לקונים, והתנהגות דף המוכר.',
    },
    event_settings: {
      title: 'תכונות הגדרות אירוע',
      description: 'שפר את הגדרות האירוע שלך עם הכלים החזקים האלה לשיפור חוויית הרוכש',
      seller_page_desc: 'כאשר מופעל, האירוע יופיע בדף המוכר הציבורי שלך, מאפשר ללקוחות לגלות ולרכוש כרטיסים ישירות מהחנות הממותגת שלך.',
      one_form_desc: 'פשט את תהליך הרכישה! כאשר קונים רוכשים מספר כרטיסים, הם צריכים למלא את הפרטים שלהם רק פעם אחת, מה שהופך רכישות מרובות למהירות וקלות יותר.',
      season_ticket_desc: 'אפשר לבעלי כרטיסי עונה להשתמש בקודים המיוחדים שלהם. שדה קלט יופיע במהלך התשלום כדי שלקוחות יוכלו להחיל את ההטבות של כרטיס העונה שלהם.',
      coupons_desc: 'הגבר מכירות עם קודי קידום מכירות! לקוחות יכולים להחיל קודי קופון במהלך התשלום כדי לקבל הנחות והצעות מיוחדות.',
    },
  },
  member_club_intro: {
    title: 'לוח שנה לניהול מועדון חברים',
    description: 'כמנהל, נהלו את כל אירועי מועדון החברים, עקבו אחר נוכחות וארגנו פעילויות מתצוגת לוח שנה מרכזית זו. ייעלו את תפעול המועדון ורישום החברים.',
    feature1_title: 'שליטה ברישום חברים',
    feature1_description: 'כמנהל, רשמו חברים לאירועים ישירות מלוח השנה עם תפריט בחירת החברים המשולב. הקצו במהירות חברים לשיעורים ופעילויות.',
    feature2_title: 'ניהול אירועים',
    feature2_description: 'צרו ונהלו סוגים שונים של אירועי מועדון כולל שיעורים רגילים, מפגשי בריאות ופעילויות חברים מיוחדות. שליטה מלאה בתזמון ובקיבולת.',
    feature3_title: 'מעקב נוכחות',
    feature3_description: 'עקבו אחר השתתפות חברים בכל האירועים עם מחווני התקדמות מפורטים. צפו בקיבולת ובסטטוס הרישום בזמן אמת במבט אחד.',
    feature4_title: 'ניהול כרטיסי עונה',
    feature4_description: 'נהלו הקצאות כרטיסי עונה ועזרו לחברים להזמין את המקומות שלהם באירועים הקרובים. שלטו בגישה ובהטבות החברים ממיקום מרכזי אחד.',
  },
};

export default he;